/* ============================================================
   THE SHORE LINE — redesign preview interactions (v2 design system)
   ============================================================ */
(function () {
  'use strict';

  var P = window.PRODUCTS || [];
  var RV = window.REVIEWS || {};
  var FIT = window.FIT || {};
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var money = function (n) { n = Math.round(Number(n) * 100) / 100; return '$' + (n % 1 ? n.toFixed(2) : n.toFixed(0)); };
  var r2 = function (n) { return Math.round(n * 100) / 100; };
  var esc = function (s) { return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/"/g, '&quot;'); };

  /* ---------------------------------------------------------
     PRODUCT SETS
  --------------------------------------------------------- */
  var G = window.GROUPS || {};
  var ST = window.STYLES || {};
  var byHandle = function (hd) { return P.filter(function (p) { return p.handle === hd; })[0]; };

  /* ---------------------------------------------------------
     REAL URLS — /products/{handle}, /collections/{handle}, /pages/{slug}
     Every page is a static file; in-site clicks use history.pushState so the
     cart (kept in memory) survives navigation.
  --------------------------------------------------------- */
  var baseEl = document.querySelector('base');
  var ROOT = new URL(baseEl ? baseEl.getAttribute('href') : './', location.href).href;
  if (baseEl) baseEl.setAttribute('href', ROOT);
  var ROOT_PATH = new URL(ROOT).pathname;
  // Shopify collection handles (existing ones match the live store)
  var SLUG = { 'all': 'shop', 'new': 'new-arrivals', 'best': 'best-sellers', 'sets': 'matching-sets', 'shea': 'the-shea',
    'accessories': 'apres-surf', 'beach-shirt': 'the-paige', 'kaitlin': 'the-hailey', 'asher': 'the-asher',
    'bridgett': 'the-bridgett', 'landon': 'the-new-landon', 'vacation': 'the-vacation', 'dresses': 'dresses',
    'shea-ss': 'the-shea-short-sleeve', 'shea-ls': 'the-shea-long-sleeve', 'pants': 'pants', 'passport': 'shop-the-passport',
    'tops': 'tops', 'bottoms': 'bottoms' };
  var SLUG_INV = {};
  Object.keys(SLUG).forEach(function (k) { SLUG_INV[SLUG[k]] = k; });
  var PAGES = window.PAGES || {};
  // Preview host serves files, not folders, so preview URLs end in .html (/products/{handle}.html).
  // On Shopify these are the native /products/{handle} and /collections/{handle} routes.
  var EXT = '';
  function pathFor(r) {
    r = (r || '').replace(/^#\/?/, '');
    var q = '', i = r.indexOf('?');
    if (i > -1) { q = r.slice(i); r = r.slice(0, i); }
    if (!r) return '' + q;
    if (r.indexOf('product/') === 0) return 'products/' + r.slice(8) + EXT + q;
    if (r.indexOf('collection/') === 0) { var k = r.slice(11); return 'collections/' + (SLUG[k] || k) + EXT + q; }
    if (r.indexOf('page/') === 0) { var pg = PAGES[r.slice(5)]; return (pg ? pg.path : r.slice(5)) + EXT + q; }
    return r + q;
  }
  function hrefFor(a) {
    var v;
    if ((v = a.getAttribute('data-go')) || (v = a.getAttribute('data-colorway'))) return 'products/' + v + EXT;
    if ((v = a.getAttribute('data-collection')) !== null) {
      var c = a.getAttribute('data-color');
      return 'collections/' + (SLUG[v] || v) + EXT + (c ? '?color=' + encodeURIComponent(c) : '');
    }
    if ((v = a.getAttribute('data-page'))) {
      var pg = PAGES[v];
      return pg ? pg.path + EXT + (a.getAttribute('data-query') ? '?' + a.getAttribute('data-query') : '') + (a.getAttribute('data-anchor') || '') : null;
    }
    if (a.hasAttribute('data-home')) return '';
    if (a.hasAttribute('data-sizeguide')) return 'pages/size-guide' + EXT;
    return null;
  }
  function wire(a) {
    if (a.getAttribute('href') !== '#') return;
    var h = hrefFor(a);
    if (h) a.setAttribute('href', h);
  }
  function wireAll(root) { (root || document).querySelectorAll('a[href="#"]').forEach(wire); }

  var pick = function (list) { return (list || []).map(byHandle).filter(Boolean); };
  var sheaAll = pick(ST.shea);
  var SETS = {
    'all': P,
    'new': pick(G['new']),
    'best': pick(G.best),
    'sets': pick(G.sets),
    'passport': pick(G.passport),
    'shea': sheaAll,
    'shea-ss': sheaAll.filter(function (p) { return !/long sleeve/i.test(p.title); }),
    'shea-ls': sheaAll.filter(function (p) { return /long sleeve/i.test(p.title); }),
    'beach-shirt': pick(ST['beach-shirt']),
    'kaitlin': pick(ST.kaitlin),
    'asher': pick(ST.asher),
    'bridgett': pick(ST.bridgett),
    'landon': pick(ST.landon),
    'vacation': pick(ST.vacation),
    'pants': pick((ST.kaitlin || []).concat(ST.vacation || [])),
    'dresses': sheaAll,
    'tops': pick((ST['beach-shirt'] || []).concat(ST.landon || [], ST['travel-t'] || [])),
    'bottoms': pick((ST.kaitlin || []).concat(ST.asher || [], ST.bridgett || [], ST.vacation || [])),
    'accessories': pick(ST['apres-sweatshirt'])
  };
  var TABFILTER = {
    'ALL': function () { return true; },
    'TUNICS': function (p) { return p.style === 'beach-shirt'; },
    'PANTS': function (p) { return p.style === 'kaitlin' || p.style === 'vacation'; },
    'SHORTS': function (p) { return p.style === 'asher'; },
    'SKIRTS': function (p) { return p.style === 'bridgett'; }
  };
  var STYLE_LABEL = {
    'shea': 'Dresses', 'beach-shirt': 'Beach Tunics', 'kaitlin': 'Pants', 'vacation': 'Pants',
    'asher': 'Shorts', 'bridgett': 'Skirts', 'landon': 'Tanks & Tops', 'travel-t': 'Tops', 'apres-sweatshirt': 'Après Surf'
  };
  var STYLE_KEY = { 'shea': 'dresses', 'beach-shirt': 'beach-shirt', 'kaitlin': 'pants', 'vacation': 'pants', 'asher': 'asher', 'bridgett': 'bridgett', 'landon': 'landon', 'travel-t': 'tops', 'apres-sweatshirt': 'accessories' };

  /* ---------------------------------------------------------
     STATE (in memory only — no storage)
  --------------------------------------------------------- */
  var cart = [];
  var wish = (window.TSL && TSL.load('wish')) || [];
  var recent = (window.TSL && TSL.load('recent')) || [];
  var discount = null; // {code, pct}

  /* ---------------------------------------------------------
     OFFER RULES (build brief 2026-09-30)
     - Only multi-buy: 2+ Shea dresses (any mix of short/long sleeve,
       colors, sizes) = 10% off those Shea dresses. Automatic.
     - Matching pieces are cross-sold at FULL PRICE (no set discount).
  --------------------------------------------------------- */
  var SHEA_PCT = 10, SHEA_TITLE = 'Buy Two Shea Dresses \u2013 10% off';
  // pairings live on the product (Shopify metafields custom.set_pieces / custom.look_pieces)

  function isShea(p) { return p && p.style === 'shea'; }
  function inStock(p) { return p && (p.sizes || []).some(function (x) { return x.q > 0; }); }
  function partnersOf(p) { return (p.set_pieces || []).map(byHandle).filter(inStock); }
  function lookOf(p) { return (p.look_pieces || []).map(byHandle).filter(inStock); }
  function sheaSecond(p) {
    var pool = P.filter(function (x) { return isShea(x) && x.handle !== p.handle && inStock(x); });
    var same = pool.filter(function (x) { return x.title === p.title; });
    return same[0] || pool[0] || (inStock(p) ? p : null);
  }
  function sheaCount() { return cart.reduce(function (n, l) { return n + (isShea(l.p) ? l.q : 0); }, 0); }
  var CODE_WINS = false;
  function lineAuto(l) { return !CODE_WINS && sheaCount() >= 2 && isShea(l.p) ? r2(l.q * l.p.price * SHEA_PCT / 100) : 0; }

  /* ---------------------------------------------------------
     PRODUCT CARD
  --------------------------------------------------------- */
  function sizeRow(p, s) {
    return (p.sizes || []).filter(function (x) { return x.s === s; })[0] || { s: s, q: 0 };
  }
  function sizeState(p, s) { return sizeRow(p, s).q > 0; }
  function sizeNames(p) { return (p.sizes || []).map(function (x) { return x.s; }); }
  /* auto-framing: every image gets a face-aware focal point (see data-focal.js) */
  var FOCAL = window.FOCAL || {};
  function frame(img) {
    var k = img.getAttribute('src');
    if (k && FOCAL[k] && !img.hasAttribute('data-noframe')) img.style.objectPosition = FOCAL[k];
  }
  function frameAll(root) { (root || document).querySelectorAll('img').forEach(frame); }
  new MutationObserver(function (muts) {
    muts.forEach(function (m) {
      m.addedNodes && m.addedNodes.forEach(function (n) {
        if (n.nodeType !== 1) return;
        if (n.tagName === 'IMG') frame(n); else { frameAll(n); if (n.tagName === 'A') wire(n); wireAll(n); }
      });
    });
  }).observe(document.documentElement, { childList: true, subtree: true });
  document.addEventListener('DOMContentLoaded', function () { frameAll(); wireAll(); });
  frameAll(); wireAll();
  if (window.REVIEWS && window.REVIEWS['The Beach Shirt'] && !window.REVIEWS['The Button-Up Beach Tunic'])
    window.REVIEWS['The Button-Up Beach Tunic'] = window.REVIEWS['The Beach Shirt'];

  function colorways(p) { return P.filter(function (x) { return x.title === p.title; }); }
  function inWish(h) { return wish.indexOf(h) > -1; }

  /* Size numbering: XS = 0, S = 1, M = 2, L = 3 */
  var SZN = { 'XS': '0', 'S': '1', 'M': '2', 'L': '3' };
  // display sizes as numbers only (0, 1, 2, 3); internal variant keys stay XS/S/M/L
  function szChip(s) { return SZN[s] != null ? SZN[s] : s; }
  var SZSHORT = { 'Small': 'S', 'Medium': 'M', 'Large': 'L' };
  function szShort(s) { return SZSHORT[s] || szChip(s); }
  function szText(s) { return SZN[s] != null ? SZN[s] : s; }
  function szDesc(h) { return (h || '').replace(/\b(size|sizes) (XS|S|M|L)\b/g, function (m, w, s) { return w + ' ' + szText(s); }); }
  var HEART = '<svg viewBox="0 0 24 24"><path d="M12 20s-7-4.4-7-9.5A3.9 3.9 0 0 1 12 8a3.9 3.9 0 0 1 7 2.5C19 15.6 12 20 12 20Z"/></svg>';

  function cardHTML(p) {
    var badge = p.badge || '';
    var sizes = sizeNames(p).map(function (s) {
      var ok = sizeState(p, s);
      return '<button data-add="' + p.handle + '" data-size="' + s + '"' +
        (ok ? '' : ' class="is-out" disabled') + '>' + szShort(s) + '</button>';
    }).join('');
    var pos = p.pos ? ' style="object-position:' + p.pos + '"' : '';
    var n = colorways(p).length;
    return '' +
      '<article class="card" data-handle="' + p.handle + '">' +
      '  <div class="card__media">' +
      (badge ? '<span class="card__badge">' + badge + '</span>' : '') +
      '    <button class="card__heart' + (inWish(p.handle) ? ' is-on' : '') + '" data-wish="' + p.handle + '" aria-label="Add to wishlist">' + HEART +
        '<span class="card__heartlbl"><em class="is-add">Add to wishlist</em><em class="is-rm">Remove from wishlist</em></span></button>' +
      '    <img class="a" src="' + p.img + '" alt="' + esc(p.title) + ' — ' + esc(p.color) + '" loading="lazy"' + pos + '>' +
      '    <img class="b" src="' + p.img2 + '" alt="" loading="lazy"' + pos + '>' +
      '    <button class="card__arrow card__arrow--l" data-cardarrow="-1" aria-label="Previous image"><svg viewBox="0 0 24 24"><path d="M15 5l-7 7 7 7"/></svg></button>' +
      '    <button class="card__arrow card__arrow--r" data-cardarrow="1" aria-label="Next image"><svg viewBox="0 0 24 24"><path d="M9 5l7 7-7 7"/></svg></button>' +
      '    <div class="card__sizes">' + sizes + '</div>' +
      '    <button class="card__quick" data-quick="' + p.handle + '" aria-label="Quick add">+</button>' +
      '  </div>' +
      '  <div class="card__info">' +
      '    <a href="#" class="card__name" data-go="' + p.handle + '">' + esc(p.title) + '</a>' +
      '    <div class="card__meta">' + esc(p.color) + ' &middot; ' + n + (n > 1 ? ' colors' : ' color') + '</div>' +
      '    <div class="card__price"><span class="now">' + money(p.price) + '</span></div>' +
      (isShea(p) ? '    <div class="card__promo">Buy two, save 10%</div>' : '') +
      '  </div>' +
      '</article>';
  }

  var ARROWS = '<button data-dir="-1" aria-label="Scroll left"><svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M15 5l-7 7 7 7"/></svg></button>' +
    '<button data-dir="1" aria-label="Scroll right"><svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M9 5l7 7-7 7"/></svg></button>';

  /* ---------------------------------------------------------
     BUILD RAILS
  --------------------------------------------------------- */
  $$('.rail[data-rail]').forEach(function (sec) {
    var key = sec.getAttribute('data-rail');
    var title = sec.getAttribute('data-title');
    var tabs = (sec.getAttribute('data-tabs') || '').split(',').filter(Boolean);
    var items = SETS[key] || [];
    sec.innerHTML = '' +
      '<div class="rail__head">' +
      '  <h3 class="rail__title">' + title + '</h3>' +
      '  <div class="rail__tools">' +
      (tabs.length ? '<div class="rail__tabs">' + tabs.map(function (t, i) {
        return '<button data-tab="' + t + '"' + (i === 0 ? ' class="is-on"' : '') + '>' + t + '</button>';
      }).join('') + '</div>' : '') +
      '    <a href="#" class="rail__viewall" data-collection="' + key + '">View All</a>' +
      '    <div class="rail__arrows">' + ARROWS + '</div>' +
      '  </div>' +
      '</div>' +
      '<div class="rail__track"></div>';
    var track = $('.rail__track', sec);
    function render(filterName) {
      var f = TABFILTER[filterName] || TABFILTER.ALL;
      var list = items.filter(f);
      if (!list.length) list = items;
      track.innerHTML = list.map(cardHTML).join('');
      updateArrows(sec);
    }
    render('ALL');
    $$('[data-tab]', sec).forEach(function (b) {
      b.addEventListener('click', function () {
        $$('[data-tab]', sec).forEach(function (x) { x.classList.remove('is-on'); });
        b.classList.add('is-on');
        render(b.getAttribute('data-tab'));
        track.scrollTo({ left: 0, behavior: 'smooth' });
      });
    });
  });

  /* ---------------------------------------------------------
     COLLECTIONS RAIL
  --------------------------------------------------------- */
  var COLLECTIONS = [
    { t: 'New Arrivals', k: 'new', img: '//thisistheshoreline.com/cdn/shop/t/16/assets/pdp-the-shea-long-sleeve-t-shirt-dress-white-0.jpg?v=62147676084297339841792639006', pos: '50% 22%' },
    { t: 'Best Sellers', k: 'best', img: '//thisistheshoreline.com/cdn/shop/t/16/assets/pdp-the-shea-t-shirt-dress-white-0.jpg?v=156539218139546518411792639008', pos: '50% 22%' },
    { t: 'The Shea', k: 'shea', img: '//thisistheshoreline.com/cdn/shop/t/16/assets/pdp-the-shea-t-shirt-dress-2.jpg?v=490464256326120761792639008', pos: '50% 50%' },
    { t: 'The Beach Tunic', k: 'beach-shirt', img: '//thisistheshoreline.com/cdn/shop/t/16/assets/pdp-the-paige-beach-shirt-0.jpg?v=145563845123567924491792639001', pos: '50% 22%' },
    { t: 'The Kaitlin Pants', k: 'kaitlin', img: '//thisistheshoreline.com/cdn/shop/t/16/assets/pdp-the-hailey-trouser-1-1.jpg?v=100956783285475054281792638993', pos: '50% 50%' },
    { t: 'The Asher Shorts', k: 'asher', img: '//thisistheshoreline.com/cdn/shop/t/16/assets/pdp-the-asher-shorts-3-1.jpg?v=43767709912439064911792638988', pos: '50% 50%' },
    { t: 'The Bridgett Skirt', k: 'bridgett', img: '//thisistheshoreline.com/cdn/shop/t/16/assets/pdp-the-bridgett-skirt-5.jpg?v=88797270124675210531792638992', pos: '50% 50%' },
    { t: 'Matching Sets', k: 'sets', img: '//thisistheshoreline.com/cdn/shop/t/16/assets/life-11.jpg?v=95492846321704186351792638983', pos: '50% 50%' },
    { t: 'Après Surf', k: 'accessories', img: '//thisistheshoreline.com/cdn/shop/t/16/assets/apres-mobile-poster.jpg?v=93352012317587079311792638983', pos: '50% 50%', fit: 'contain' }
  ];
  $('#colTrack').innerHTML = COLLECTIONS.map(function (c) {
    var n = (SETS[c.k] || []).length;
    var sub = n === 0 ? 'Coming soon' : n + (n === 1 ? ' piece' : ' pieces');
    return '<a href="#" class="colcard" data-collection="' + c.k + '">' +
      '<img src="' + c.img + '" alt="' + c.t + '" loading="lazy" style="object-position:' + c.pos + (c.fit ? ';object-fit:' + c.fit + ';background:#dbd5c9' : '') + '">' +
      '<div class="colcard__scrim"></div><div class="colcard__label"><b>' + c.t + '</b><i>' + sub + '</i></div></a>';
  }).join('');
  $('#collections .rail__arrows').innerHTML = ARROWS;


  /* ---------------------------------------------------------
     PRESS MARQUEE
  --------------------------------------------------------- */
  var PRESS = ['press-wwd.jpg', 'press-littlepinktop.jpg', 'press-citylifestyle.jpg', 'press-texas.jpg',
    'press-beyondfashion.jpg', 'press-authority.jpg', 'press-studio512.jpg', 'press-awwoman.png'];
  var pressHTML = (window.PRESS_STRIP || []).map(function (x) {
    return '<a href="' + x[2] + '" target="_blank" rel="noopener" title="' + x[1] + '"><img src="' + window.TSL_ASSET + x[0] + '" alt="' + x[1] + '" loading="lazy"></a>';
  }).join('');
  $('#pressTrack').innerHTML = pressHTML + pressHTML;

  /* ---------------------------------------------------------
     COMMUNITY PICKS (UGC)
  --------------------------------------------------------- */
  var UGC = [
    { h: '@lauren.k', img: '//thisistheshoreline.com/cdn/shop/t/16/assets/life-01.jpg?v=174335178182660982191792638983', items: ['the-paige-shirt-stripe', 'the-hailey-trouser-1', 'the-new-landon-tank'] },
    { h: '@coastal.edit', img: '//thisistheshoreline.com/cdn/shop/t/16/assets/life-06.jpg?v=68942945936970129601792638983', items: ['the-shea-t-shirt-dress-white', 'the-paige-beach-shirt'] },
    { h: '@sailwithsam', img: '//thisistheshoreline.com/cdn/shop/t/16/assets/life-14.jpg?v=89096995320157011041792638984', items: ['the-paige-beach-shirt-1', 'the-hailey-trouser', 'the-new-landon-tank'] },
    { h: '@mariemcgrath', img: '//thisistheshoreline.com/cdn/shop/t/16/assets/life-09.jpg?v=46357285430138059091792638982', items: ['the-beach-shirt', 'the-asher-shorts', 'the-new-landon-tank'] },
    { h: '@thetravelfile', img: '//thisistheshoreline.com/cdn/shop/t/16/assets/life-11.jpg?v=95492846321704186351792638983', items: ['the-shea-t-shirt-dress', 'the-paige-shirt'] },
    { h: '@islandmornings', img: '//thisistheshoreline.com/cdn/shop/t/16/assets/life-17.jpg?v=162124102755140820211792638984', items: ['the-paige-beach-shirt', 'the-vacation-pants-copy', 'the-new-landon'] },
    { h: '@clearwater.co', img: '//thisistheshoreline.com/cdn/shop/t/16/assets/life-12.jpg?v=82162373702632542041792638984', items: ['the-paige-shirt-stripe', 'the-asher-shorts-2', 'the-new-landon'] },
    { h: '@bysoleil', img: '//thisistheshoreline.com/cdn/shop/t/16/assets/life-18.jpg?v=40944524579531100331792638984', items: ['the-shea-long-sleeve-t-shirt-dress-white', 'the-paige-beach-shirt'] },
    { h: '@paige.travels', img: '//thisistheshoreline.com/cdn/shop/t/16/assets/life-15.jpg?v=33730126101056536311792638984', items: ['the-bridgett-skirt', 'the-beach-shirt', 'the-new-landon-tank'] }
  ];
  function ugcCard(u, i) {
    return '<div class="ugccard" data-look="' + i + '"><img src="' + u.img + '" alt="Community photo" loading="lazy">' +
      '<div class="ugccard__handle">' + u.h + '</div><div class="ugccard__shop">Shop the Look</div></div>';
  }
  // Community Picks removed for now (Oct 19) — UGC data kept for later
  $$('#pdpRail .rail__arrows, #pdpRecent .rail__arrows').forEach(function (el) { el.innerHTML = ARROWS; });

  /* ---------------------------------------------------------
     RAIL ARROWS
  --------------------------------------------------------- */
  function updateArrows(sec) {
    var track = $('.rail__track', sec);
    var l = $('[data-dir="-1"]', sec), r = $('[data-dir="1"]', sec);
    if (!track || !l || !r) return;
    l.disabled = track.scrollLeft < 8;
    r.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 8;
  }
  $$('.rail').forEach(function (sec) {
    var track = $('.rail__track', sec);
    if (!track) return;
    $$('[data-dir]', sec).forEach(function (b) {
      b.addEventListener('click', function () {
        var step = track.clientWidth * 0.72 * (+b.getAttribute('data-dir'));
        track.scrollBy({ left: step, behavior: 'smooth' });
      });
    });
    track.addEventListener('scroll', function () { updateArrows(sec); });
    updateArrows(sec);
  });
  window.addEventListener('resize', function () { $$('.rail').forEach(updateArrows); });

  /* ---------------------------------------------------------
     ANNOUNCEMENT ROTATOR
  --------------------------------------------------------- */
  var annItems = $$('#ann .ann__item'), annI = 0, annTimer;
  function annGo(step) {
    annItems[annI].classList.remove('is-on');
    annI = (annI + step + annItems.length) % annItems.length;
    annItems[annI].classList.add('is-on');
  }
  function annStart() { annTimer = setInterval(function () { annGo(1); }, 4200); }
  annStart();
  $$('[data-ann]').forEach(function (b) {
    b.addEventListener('click', function () {
      clearInterval(annTimer); annGo(+b.getAttribute('data-ann')); annStart();
    });
  });

  /* ---------------------------------------------------------
     HEADER + MEGA MENU
  --------------------------------------------------------- */
  var header = $('#header');
  window.addEventListener('scroll', function () {
    header.classList.toggle('is-stuck', window.scrollY > 4);
  });
  var megaTimer = null, openMega = null;
  function closeMega() {
    if (openMega) { $('#mega-' + openMega).classList.remove('is-open'); }
    $$('.navitem').forEach(function (n) { n.classList.remove('is-open'); });
    openMega = null;
  }
  $$('.navitem').forEach(function (item) {
    var key = item.getAttribute('data-mega');
    var panel = $('#mega-' + key);
    if (!panel) return;
    function openIt() {
      clearTimeout(megaTimer);
      if (openMega === key) return;
      closeMega();
      panel.classList.add('is-open');
      item.classList.add('is-open');
      openMega = key;
    }
    item.addEventListener('mouseenter', openIt);
    item.addEventListener('focus', openIt);
    panel.addEventListener('mouseenter', function () { clearTimeout(megaTimer); });
    [item, panel].forEach(function (el) {
      el.addEventListener('mouseleave', function () { megaTimer = setTimeout(closeMega, 180); });
    });
  });
  header.addEventListener('mouseleave', function () { megaTimer = setTimeout(closeMega, 180); });

  /* ---------------------------------------------------------
     OVERLAY MANAGER
  --------------------------------------------------------- */
  var scrim = $('#scrim');
  var openLayers = [];
  function open(sel) {
    var el = $(sel);
    if (!el || openLayers.indexOf(sel) > -1) return;
    closeMega();
    el.classList.add('is-on');
    openLayers.push(sel);
    scrim.classList.add('is-on');
    document.body.classList.add('no-scroll');
  }
  function close(sel) {
    var el = $(sel);
    if (el) el.classList.remove('is-on');
    openLayers = openLayers.filter(function (s) { return s !== sel; });
    if (!openLayers.length) {
      scrim.classList.remove('is-on');
      // pages are real in-flow pages now, so always release the scroll lock once nothing is open
      document.body.classList.remove('no-scroll');
    }
    if (sel === '#welcome' && seen.welcome && !$('#sideTab').classList.contains('is-hidden')) $('#sideTab').classList.add('is-on');
  }
  function closeAll() { openLayers.slice().forEach(close); }
  scrim.addEventListener('click', closeAll);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(); });
  $$('[data-close]').forEach(function (b) {
    b.addEventListener('click', function () {
      var host = b.closest('.modal,.drawer,.searchpanel,.mnav');
      if (host) close('#' + host.id);
    });
  });
  var seen = {};
  function mark(k) { seen[k] = 1; }

  /* ---------------------------------------------------------
     WELCOME / SCRATCH CARD (10% off first order — personalized code sent by the Klaviyo welcome flow)
  --------------------------------------------------------- */
  var scratchReady = false;
  function buildScratch() {
    var cv = $('#scratchCanvas'), ctx = cv.getContext('2d');
    ctx.globalCompositeOperation = 'source-over';
    ctx.clearRect(0, 0, cv.width, cv.height);
    var g = ctx.createLinearGradient(0, 0, cv.width, cv.height);
    g.addColorStop(0, '#cfc7bb'); g.addColorStop(.5, '#b9afa1'); g.addColorStop(1, '#c7bfb2');
    ctx.fillStyle = g; ctx.fillRect(0, 0, cv.width, cv.height);
    ctx.globalAlpha = .12;
    for (var i = 0; i < 900; i++) {
      ctx.fillStyle = i % 2 ? '#fff' : '#8b8175';
      ctx.fillRect(Math.random() * cv.width, Math.random() * cv.height, 2, 2);
    }
    ctx.globalAlpha = 1;
    ctx.globalCompositeOperation = 'destination-out';
    var drawing = false, cleared = false;
    function pos(e) {
      var r = cv.getBoundingClientRect();
      var x = (e.touches ? e.touches[0].clientX : e.clientX) - r.left;
      var y = (e.touches ? e.touches[0].clientY : e.clientY) - r.top;
      return { x: x * cv.width / r.width, y: y * cv.height / r.height };
    }
    function scratch(e) {
      if (!drawing) return;
      var p = pos(e);
      ctx.beginPath(); ctx.arc(p.x, p.y, 20, 0, Math.PI * 2); ctx.fill();
      $('.scratch__hint').style.opacity = 0;
      if (!cleared && cleanedPct() > 42) { cleared = true; reveal(); }
    }
    function cleanedPct() {
      var d = ctx.getImageData(0, 0, cv.width, cv.height).data, n = 0;
      for (var i = 3; i < d.length; i += 40) { if (d[i] === 0) n++; }
      return n / (d.length / 40) * 100;
    }
    function reveal() {
      cv.style.transition = 'opacity .5s'; cv.style.opacity = 0;
      setTimeout(function () { cv.style.display = 'none'; }, 500);
      $('#welcomeForm').classList.add('is-on');
      $('#welcomeTitle').textContent = 'You got 10% off';
      $('#welcomeSub').textContent = 'Enter your email to unlock it';
    }
    if (!scratchReady) {
      ['mousedown', 'touchstart'].forEach(function (t) {
        cv.addEventListener(t, function (e) { drawing = true; scratch(e); e.preventDefault(); });
      });
      ['mousemove', 'touchmove'].forEach(function (t) {
        cv.addEventListener(t, function (e) { scratch(e); if (drawing) e.preventDefault(); });
      });
      ['mouseup', 'mouseleave', 'touchend'].forEach(function (t) {
        cv.addEventListener(t, function () { drawing = false; });
      });
    }
    scratchReady = true;
  }
  /* Mirrors the OptiMonk rules from the 5 Oct brief: shows after 8–12 s OR 40–50% scroll
     (whichever first), exit intent on desktop as backup, never while the cart is open.
     On launch OptiMonk replaces this block and handles frequency (7–14 days, never for subscribers). */
  var welcomeArmed = !/[?&]qa\b/.test(location.search);
  function startWelcome(force) {
    if (!force && document.documentElement.classList.contains('is-phoneview')) return; // phone preview shows its own popup
    if (!force && (seen.welcome || !welcomeArmed || (window.TSL && TSL.popAllowed && !TSL.popAllowed()))) return;
    if (openLayers.indexOf('#cartDrawer') > -1) { setTimeout(function () { startWelcome(force); }, 4000); return; }
    if (!scratchReady) buildScratch();
    open('#welcome');
    mark('welcome');
    if (window.TSL && TSL.popShown) TSL.popShown();
  }
  var popDelay = 8000 + Math.round(Math.random() * 4000);
  var popTimer = setTimeout(startWelcome, popDelay);
  var popScroll = 0.40 + Math.random() * 0.10;
  window.addEventListener('scroll', function onPopScroll() {
    var h = document.documentElement.scrollHeight - window.innerHeight;
    if (h > 0 && window.scrollY / h >= popScroll) { window.removeEventListener('scroll', onPopScroll); clearTimeout(popTimer); startWelcome(); }
  }, { passive: true });
  if (window.matchMedia('(pointer:fine)').matches) {
    document.addEventListener('mouseout', function (e) {
      if (!e.relatedTarget && e.clientY <= 0) { clearTimeout(popTimer); startWelcome(); }
    });
  }
  function uniqueCode() {
    var c = 'ABCDEFGHJKLMNPQRSTUVWXYZ23456789', o = '';
    for (var i = 0; i < 5; i++) o += c[Math.floor(Math.random() * c.length)];
    return 'TSL15-' + o;
  }
  var issuedCode = null;
  $('#welcomeForm').addEventListener('submit', function (e) {
    e.preventDefault();
    var email = $('#welcomeEmail').value.trim();
    issuedCode = uniqueCode();
    // On launch: OptiMonk -> Klaviyo Welcome list (source "Popup - Scratch"), unique Shopify code in the welcome email,
    // Meta Lead event (Pixel + Conversions API).
    if (window.TSL && TSL.subscribe) TSL.subscribe(email, 'Popup - Scratch');
    if (window.fbq) window.fbq('track', 'Lead');
    document.dispatchEvent(new CustomEvent('tsl:lead', { detail: { email: email, source: 'Popup - Scratch' } }));
    this.classList.remove('is-on'); this.style.display = 'none';
    $('#welcomeTitle').textContent = 'One more thing';
    $('#welcomeSub').textContent = 'Want updates by text too?';
    $('#welcomeSms').classList.add('is-on');
    $('#welcomeSent').textContent = 'Sent to ' + email + ' \u00b7 valid once on your first order.';
  });
  function finishWelcome(sms) {
    $('#welcomeSms').classList.remove('is-on'); $('#welcomeSms').style.display = 'none';
    $('#welcomeTitle').textContent = 'Your 10% is unlocked';
    $('#welcomeSub').textContent = 'Check your inbox in a few minutes.';
    $('#welcomeCode').classList.add('is-on');
    $('#sideTab').classList.add('is-claimed');
  }
  $('#welcomeSms').addEventListener('submit', function (e) {
    e.preventDefault();
    var ph = $('#welcomePhone').value.trim();
    if (window.TSL && TSL.subscribeSms && ph && !TSL.subscribeSms(ph, 'Popup - Scratch')) { $('#welcomePhone').setCustomValidity('Enter a 10-digit U.S. mobile number'); $('#welcomePhone').reportValidity(); $('#welcomePhone').setCustomValidity(''); return; }
    finishWelcome(!!ph);
  });
  $('#welcomeSkip').addEventListener('click', function () { finishWelcome(false); });
  $('#sideTab').addEventListener('click', function (e) {
    if (e.target.closest('[data-teaserx]')) { $('#sideTab').classList.remove('is-on'); $('#sideTab').classList.add('is-hidden'); if (window.TSL) TSL.save('tabx', 1); return; }
    startWelcome(true);
  });

  /* ---------------------------------------------------------
     SEARCH
  --------------------------------------------------------- */
  var SUGG = ['Beach tunic', 'Matching set', 'The Shea', 'Kaitlin pants', 'Polka dot', 'Passport', 'Bridgett skirt', 'White dress'];
  $('#sugg').innerHTML = SUGG.map(function (s) { return '<button>' + s + '</button>'; }).join('');
  var featured = SETS.best.slice(0, 5);
  function renderSearch(q) {
    var list;
    if (!q) { list = featured; $('#searchResHead').textContent = 'Featured'; }
    else {
      var t = q.toLowerCase();
      list = P.filter(function (p) {
        return (p.title + ' ' + p.color + ' ' + p.style).toLowerCase().indexOf(t) > -1;
      });
      $('#searchResHead').textContent = list.length ? list.length + ' result' + (list.length > 1 ? 's' : '') : 'No matches';
    }
    $('#searchRes').innerHTML = list.length ? list.map(cardHTML).join('') :
      '<div class="searchempty">Nothing matched “' + esc(q) + '”. Try “set”, “shirt” or “dress”.</div>';
  }
  renderSearch('');
  $('#searchInput').addEventListener('input', function () { renderSearch(this.value.trim()); });
  $$('#sugg button').forEach(function (b) {
    b.addEventListener('click', function () {
      $('#searchInput').value = b.textContent;
      renderSearch(b.textContent);
    });
  });
  function openSearch() {
    open('#searchPanel');
    setTimeout(function () { $('#searchInput').focus(); }, 260);
  }
  $('#openSearch').addEventListener('click', openSearch);
  $('#openSearchM').addEventListener('click', openSearch);
  $('#floatSearch').addEventListener('click', openSearch);
  $('#openAccount').addEventListener('click', function () { location.href = '/account'; });

  /* ---------------------------------------------------------
     CART
  --------------------------------------------------------- */
  function cartQty() { return cart.reduce(function (n, l) { return n + l.q; }, 0); }
  function cartSum() { return cart.reduce(function (n, l) { return n + l.q * l.p.price; }, 0); }
  function recoFor() {
    var inCart = cart.map(function (l) { return l.p.handle; });
    var titles = cart.map(function (l) { return l.p.title; });
    var skip = cartUpsellHandles();
    var out = [];
    function ok(x) { return inStock(x) && inCart.indexOf(x.handle) === -1 && titles.indexOf(x.title) === -1 && skip.indexOf(x.handle) === -1 && out.indexOf(x) === -1; }
    cart.forEach(function (l) { partnersOf(l.p).forEach(function (x) { if (ok(x)) out.push(x); }); });
    cart.forEach(function (l) { P.forEach(function (x) { if (x.color === l.p.color && ok(x)) out.push(x); }); });
    SETS.best.forEach(function (x) { if (ok(x)) out.push(x); });
    // never repeat a style twice in the row
    var seenT = {};
    out = out.filter(function (x) { if (seenT[x.title]) return false; seenT[x.title] = 1; return true; });
    return out.slice(0, 6);
  }
  function miniCard(p) {
    var sizes = sizeNames(p).map(function (s) {
      var ok = sizeState(p, s);
      return '<button data-add="' + p.handle + '" data-size="' + s + '"' + (ok ? '' : ' class="is-out" disabled') + '>' + szChip(s) + '</button>';
    }).join('');
    return '<div class="mini">' +
      '<a href="#" class="mini__img" data-go="' + p.handle + '"><img src="' + p.img + '" alt="' + esc(p.title) + '"' + (p.pos ? ' style="object-position:' + p.pos + '"' : '') + '></a>' +
      '<div class="mini__name">' + esc(p.title) + '</div>' +
      '<div class="mini__meta">' + esc(p.color) + ' &middot; ' + money(p.price) + '</div>' +
      '<div class="mini__sizes">' + sizes + '</div>' +
      '</div>';
  }
  function chipRow(p, attrAdd) {
    return sizeNames(p).map(function (sz) {
      var okz = sizeState(p, sz);
      return '<button ' + attrAdd + '="' + p.handle + '" data-size="' + sz + '"' + (okz ? '' : ' class="is-out" disabled') + '>' + szChip(sz) + '</button>';
    }).join('');
  }
  function cartShea() {
    var n = sheaCount();
    if (n === 1) {
      var mine = cart.filter(function (l) { return isShea(l.p); })[0].p;
      var nx = sheaSecond(mine);
      if (!nx) return { html: '', h: null };
      return { h: nx.handle, html: '<div class="ccs ccs--shea">' +
        '<p class="ccs__eyebrow">Add one more Shea dress, save 10% on both</p>' +
        '<div class="ccs__row"><a href="#" data-go="' + nx.handle + '"><img class="ccs__img" src="' + nx.img + '" alt="' + esc(nx.title) + '"></a>' +
        '<div class="ccs__info"><p class="ccs__title">' + esc(nx.title) + ' \u2014 ' + esc(nx.color) + '</p>' +
        '<p class="ccs__meta">' + money(nx.price) + ', 10% off applies automatically</p>' +
        '<div class="ccs__sizes">' + chipRow(nx, 'data-add') + '</div></div></div></div>' };
    }
    if (n >= 2) return { h: null, html: '<p class="ccs__done"><svg viewBox="0 0 24 24"><path d="M5 12.5l4.2 4.2L19 7"/></svg>' + SHEA_TITLE.replace(' \u2013 ', ': ') + ' applied</p>' };
    return { h: null, html: '' };
  }
  var lastAdded = null; // {h, s}
  function cartSet() {
    if (!lastAdded) return { h: null, html: '' };
    var src = byHandle(lastAdded.h);
    if (!src) return { h: null, html: '' };
    var inCart = cart.map(function (l) { return l.p.handle; });
    if (inCart.indexOf(src.handle) < 0) return { h: null, html: '' };
    var miss = partnersOf(src).filter(function (x) { return inCart.indexOf(x.handle) < 0; });
    if (!miss.length) return { h: null, html: '' };
    var rows = miss.map(function (sg) {
      var same = lastAdded.s && sizeState(sg, lastAdded.s) ? lastAdded.s : null;
      var sizesHTML = sizeNames(sg).map(function (sz) {
        var okz = sizeState(sg, sz);
        return '<button data-setsize="' + sz + '"' + (okz ? '' : ' class="is-out" disabled') + (sz === same ? ' class="is-on"' : '') + '>' + szChip(sz) + '</button>';
      }).join('');
      return '<div class="cset__row" data-h="' + sg.handle + '" data-size="' + (same || '') + '">' +
        '<a href="#" data-go="' + sg.handle + '"><img class="ccs__img" src="' + sg.img + '" alt="' + esc(sg.title) + ' \u2014 ' + esc(sg.color) + '"></a>' +
        '<div class="ccs__info"><p class="ccs__title">' + esc(sg.title) + '</p>' +
        '<p class="ccs__meta">' + esc(sg.color) + ' &middot; ' + money(sg.price) + '</p>' +
        '<div class="cset__line"><div class="cset__sizes">' + sizesHTML + '</div>' +
        '<button class="btn btn--dark btn--sm cset__add" data-setadd' + (same ? '' : ' disabled') + '>' + (same ? 'Add ' + szText(same) : 'Size') + '</button></div>' +
        (same ? '' : '<p class="cset__note">Size ' + esc(szText(lastAdded.s || '')) + ' is sold out in this piece.</p>') +
        '</div></div>';
    }).join('');
    return { h: miss[0].handle, hs: miss.map(function (x) { return x.handle; }), html: '<div class="cset" id="cartSetBox">' +
      '<p class="ccs__eyebrow">Complete the set <span class="cset__sub">Matches your ' + esc(src.title.replace(/^The /, '')) + ' in ' + esc(src.color.toLowerCase()) + '</span></p>' +
      rows + '</div>' };
  }
  function cartUpsellHandles() { return [cartShea().h].concat(cartSet().hs || []).filter(Boolean); }
  function renderCart() {
    var q = cartQty(), sum = cartSum();
    CODE_WINS = false;
    var auto = r2(cart.reduce(function (n, l) { return n + lineAuto(l); }, 0));
    var disc = discount ? r2(sum * discount.pct / 100) : 0;
    if (disc && disc >= auto) { CODE_WINS = true; auto = 0; } else disc = 0;
    $('#cartCount').textContent = q;
    $('#cartCount2').textContent = q;
    $('#cartSub').textContent = money(sum);
    $('#cartTotal').textContent = money(r2(sum - auto - disc));
    $('#autoRow').style.display = auto ? '' : 'none';
    if (auto) $('#cartAuto').textContent = '\u2212' + money(auto);
    $('#discRow').style.display = disc ? '' : 'none';
    if (disc) { $('#discName').textContent = discount.code; $('#cartDisc').textContent = '\u2212' + money(disc); }
    var up = cart.length ? cartShea().html : '';
    $('#cartUpsells').innerHTML = up;
    $('#cartUpsells').style.display = up ? '' : 'none';
    var cs = cart.length ? cartSet().html : '';
    $('#cartSet').innerHTML = cs;
    $('#cartSet').style.display = cs ? '' : 'none';
    if (!cart.length) {
      $('#cartItems').innerHTML = '<div class="drawer__empty">Your cart is empty.<br>Start with <a href="#" data-collection="new">new arrivals</a>.</div>';
    } else {
      $('#cartItems').innerHTML = cart.map(function (l, i) {
        return '<div class="litem">' +
          '<a href="#" data-go="' + l.p.handle + '"><img src="' + l.p.img + '" alt="' + esc(l.p.title) + '"' + (l.p.pos ? ' style="object-position:' + l.p.pos + '"' : '') + '></a>' +
          '<div>' +
          '<b>' + esc(l.p.title) + '</b>' +
          '<span>' + esc(l.p.color) + ' &middot; Size ' + szText(l.size) + '</span>' +
          '<div class="litem__row">' +
          '<div class="qty"><button data-q="-1" data-i="' + i + '">&minus;</button><span>' + l.q + '</span><button data-q="1" data-i="' + i + '">+</button></div>' +
          (lineAuto(l)
            ? '<span class="litem__price"><s>' + money(l.q * l.p.price) + '</s> ' + money(r2(l.q * l.p.price - lineAuto(l))) + '</span>'
            : '<span>' + money(l.q * l.p.price) + '</span>') +
          '</div>' +
          (lineAuto(l) ? '<div class="litem__disc">' + SHEA_TITLE + ' (\u2212' + money(lineAuto(l)) + ')</div>' : '') +
          '<div class="litem__row"><button class="litem__rm" data-rm="' + i + '">Remove</button></div>' +
          '</div></div>';
      }).join('');
    }
    var reco = recoFor();
    $('#cartReco').innerHTML = reco.map(miniCard).join('');
    $('#cartRecoWrap').style.display = reco.length ? '' : 'none';
    if (window.TSL && TSL.cartChanged) TSL.cartChanged();
  }
  $('#cartItems').addEventListener('click', function (e) {
    var b = e.target.closest('[data-q]');
    if (b) {
      var i = +b.getAttribute('data-i');
      cart[i].q += +b.getAttribute('data-q');
      if (cart[i].q < 1) cart.splice(i, 1);
      renderCart(); return;
    }
    var rm = e.target.closest('[data-rm]');
    if (rm) { cart.splice(+rm.getAttribute('data-rm'), 1); renderCart(); }
  });
  $('#cartSet').addEventListener('click', function (e) {
    var row = e.target.closest('.cset__row'); if (!row) return;
    var b = e.target.closest('[data-setsize]');
    if (b && !b.disabled) {
      row.setAttribute('data-size', b.getAttribute('data-setsize'));
      row.querySelectorAll('[data-setsize]').forEach(function (x) { x.classList.toggle('is-on', x === b); });
      var add = row.querySelector('[data-setadd]'); add.disabled = false; add.textContent = 'Add ' + szText(b.getAttribute('data-setsize'));
      return;
    }
    if (e.target.closest('[data-setadd]')) {
      var h = row.getAttribute('data-h'), sz = row.getAttribute('data-size');
      if (!sz) return;
      var p = byHandle(h);
      var line = cart.filter(function (l) { return l.p.handle === h && l.size === sz; })[0];
      if (line) line.q++; else cart.push({ p: p, size: sz, q: 1 });
      renderCart();
      toast(p.title + ' \u00b7 ' + sz + ' added');
    }
  });
  $('#recoArrows').innerHTML = ARROWS;
  $$('#recoArrows [data-dir]').forEach(function (b) {
    b.addEventListener('click', function () {
      $('#cartReco').scrollBy({ left: 200 * (+b.getAttribute('data-dir')), behavior: 'smooth' });
    });
  });
  $('#discForm').addEventListener('submit', function (e) {
    e.preventDefault();
    var v = $('#discInput').value.trim().toUpperCase();
    if (window.TSL && TSL.applyCode) { TSL.applyCode(v); return; }
    if (v === 'WELCOME15' || /^TSL15-[A-Z0-9]{5}$/.test(v)) {
      discount = { code: v, pct: 15 };
      $('#discMsg').textContent = v + ' applied \u2014 15% off your first order.';
      $('#discMsg').className = 'disc__msg is-ok';
    } else {
      discount = null;
      $('#discMsg').textContent = v ? 'That code isn\u2019t valid.' : 'Enter a code to apply it.';
      $('#discMsg').className = 'disc__msg is-err';
    }
    renderCart();
  });
  $('#checkoutBtn').addEventListener('click', function () { if (window.TSL && TSL.checkout) TSL.checkout(); });
  renderCart();

  function addMany(items) {
    lastAdded = items.length ? { h: items[0].h, s: items[0].s } : null;
    items.forEach(function (it) {
      var p = byHandle(it.h);
      var line = cart.filter(function (l) { return l.p.handle === it.h && l.size === it.s; })[0];
      if (line) line.q++; else cart.push({ p: p, size: it.s, q: 1 });
    });
    renderCart();
    close('#wishDrawer');
    open('#cartDrawer');
    toast(items.length + ' pieces added');
  }
  function addToCart(handle, size) {
    var p = byHandle(handle);
    if (!p) return;
    lastAdded = { h: handle, s: size };
    var line = cart.filter(function (l) { return l.p.handle === handle && l.size === size; })[0];
    if (line) line.q++; else cart.push({ p: p, size: size, q: 1 });
    renderCart();
    close('#wishDrawer');
    open('#cartDrawer');
    toast(p.title + ' · ' + size + ' added');
  }
  $('#openCart').addEventListener('click', function () { open('#cartDrawer'); });
  $$('[data-openbag]').forEach(function (b) { b.addEventListener('click', function () { open('#cartDrawer'); }); });

  /* ---------------------------------------------------------
     WISHLIST
  --------------------------------------------------------- */
  function renderWish() {
    $('#wishCount').textContent = wish.length;
    $('#wishCount2').textContent = wish.length;
    $$('[data-wish]').forEach(function (b) { b.classList.toggle('is-on', inWish(b.getAttribute('data-wish'))); });
    if (!wish.length) {
      $('#wishItems').innerHTML = '<div class="drawer__empty">Nothing saved yet.<br>Tap the heart on any piece to keep it here.</div>';
      return;
    }
    $('#wishItems').innerHTML = wish.map(byHandle).filter(Boolean).map(function (p) {
      var sizes = sizeNames(p).map(function (s) {
        var ok = sizeState(p, s);
        return '<button data-add="' + p.handle + '" data-size="' + s + '"' + (ok ? '' : ' class="is-out" disabled') + '>' + szChip(s) + '</button>';
      }).join('');
      return '<div class="litem">' +
        '<a href="#" data-go="' + p.handle + '"><img src="' + p.img + '" alt="' + esc(p.title) + '"' + (p.pos ? ' style="object-position:' + p.pos + '"' : '') + '></a>' +
        '<div>' +
        '<b>' + esc(p.title) + '</b>' +
        '<span>' + esc(p.color) + ' &middot; ' + money(p.price) + '</span>' +
        '<div class="mini__sizes">' + sizes + '</div>' +
        '<div class="litem__row"><button class="litem__rm" data-unwish="' + p.handle + '">Remove</button></div>' +
        '</div></div>';
    }).join('');
  }
  function toggleWish(h) {
    var i = wish.indexOf(h);
    if (i > -1) { wish.splice(i, 1); toast('Removed from wishlist'); }
    else { wish.push(h); toast('Saved to wishlist'); }
    if (window.TSL) TSL.save('wish', wish);
    renderWish();
  }
  renderWish();
  $('#openWish').addEventListener('click', function () { open('#wishDrawer'); });
  $$('[data-openwish]').forEach(function (b) { b.addEventListener('click', function () { open('#wishDrawer'); }); });

  /* ---------------------------------------------------------
     GLOBAL CLICK DELEGATION
  --------------------------------------------------------- */
  document.addEventListener('click', function (e) {
    var t = e.target;
    var el;
    // cmd/ctrl/shift/middle-click on a real link: let the browser open it in a new tab
    if ((e.metaKey || e.ctrlKey || e.shiftKey || e.button === 1) && (el = t.closest('a[href]')) && el.getAttribute('href') !== '#') return;
    if ((el = t.closest('[data-back]'))) {
      e.preventDefault();
      var sameSite = false;
      try { sameSite = !!document.referrer && new URL(document.referrer).origin === location.origin; } catch (x) {}
      var inApp = !!(history.state && history.state.d > 0);
      if ((inApp || sameSite) && history.length > 1) history.back();
      else go('#/collection/' + (el.getAttribute('data-back') || 'all'));
      return;
    }
    if ((el = t.closest('[data-add]')) && !el.disabled) {
      e.preventDefault();
      addToCart(el.getAttribute('data-add'), el.getAttribute('data-size'));
      return;
    }
    if ((el = t.closest('[data-quick]'))) {
      e.preventDefault();
      var media = el.closest('.card__media');
      if (media) media.classList.toggle('is-open');
      return;
    }
    if ((el = t.closest('[data-wish]'))) {
      e.preventDefault();
      toggleWish(el.getAttribute('data-wish'));
      return;
    }
    if ((el = t.closest('[data-unwish]'))) {
      e.preventDefault();
      toggleWish(el.getAttribute('data-unwish'));
      return;
    }
    if ((el = t.closest('[data-cardarrow]'))) {
      e.preventDefault();
      el.closest('.card__media').classList.toggle('is-alt');
      return;
    }
    if ((el = t.closest('[data-go]'))) {
      e.preventDefault();
      go('#/product/' + el.getAttribute('data-go'));
      return;
    }
    if ((el = t.closest('a[data-page]'))) {
      e.preventDefault();
      var qs = el.getAttribute('data-query');
      go('#/page/' + el.getAttribute('data-page') + (qs ? '?' + qs : ''), el.getAttribute('data-anchor') || '');
      return;
    }
    if ((el = t.closest('a[data-home]'))) {
      e.preventDefault();
      go('');
      return;
    }
    if ((el = t.closest('[data-sizeguide]'))) {
      e.preventDefault();
      openSizeGuide(el.getAttribute('data-sizeguide') || '');
      return;
    }
    if ((el = t.closest('[data-scroll]'))) {
      e.preventDefault();
      var target = el.getAttribute('data-scroll');
      closeAll();
      if (activeView) { if (window.TSL_LIVE) { location.href = ROOT + target; return; } go(''); }
      setTimeout(function () { var n = $(target); if (n) n.scrollIntoView({ behavior: 'smooth', block: 'center' }); }, 60);
      return;
    }
    if ((el = t.closest('[data-look]'))) {
      e.preventDefault();
      openLook(+el.getAttribute('data-look'));
      return;
    }
    if (t.closest('[data-pdpsize],#pdpAdd,.card__sizes,[data-favmore],[data-notify],[data-colorway],[data-tab],[data-dir]')) return;
    var card = t.closest('.card[data-handle]');
    if (card) {
      e.preventDefault();
      go('#/product/' + card.getAttribute('data-handle'));
      return;
    }
    var coll = t.closest('[data-collection]');
    if (coll) {
      e.preventDefault();
      var k = coll.getAttribute('data-collection');
      var c = coll.getAttribute('data-color');
      go('#/collection/' + k + (c ? '?color=' + encodeURIComponent(c) : ''));
    }
  });

  /* ---------------------------------------------------------
     SHOP THE LOOK
  --------------------------------------------------------- */
  function openLook(i) {
    var u = UGC[i];
    $('#lookImg').src = u.img;
    $('#lookHandle').textContent = u.h;
    var picks = pick(u.items);
    $('#lookItems').innerHTML = picks.map(function (p) {
      return '<div class="lookitem">' +
        '<a href="#" data-go="' + p.handle + '"><img src="' + p.img + '" alt="' + esc(p.title) + '"' + (p.pos ? ' style="object-position:' + p.pos + '"' : '') + '></a>' +
        '<div><b>' + esc(p.title) + '</b><span>' + esc(p.color) + ' &middot; ' + money(p.price) + '</span>' +
        '<div class="mini__sizes">' + sizeNames(p).map(function (s) {
          var ok = sizeState(p, s);
          return '<button data-add="' + p.handle + '" data-size="' + s + '"' + (ok ? '' : ' class="is-out" disabled') + '>' + szChip(s) + '</button>';
        }).join('') + '</div></div>' +
        '</div>';
    }).join('');
    open('#look');
  }

  /* ---------------------------------------------------------
     NEWSLETTER FORMS
  --------------------------------------------------------- */
  $('#clubForm').addEventListener('submit', function (e) {
    e.preventDefault();
    if (window.TSL && TSL.subscribe) TSL.subscribe(this.querySelector('input[type=email]').value, 'Shore Line Club');
    $('#club').classList.add('is-done');
  });
  $('#footerForm').addEventListener('submit', function (e) {
    e.preventDefault();
    if (window.TSL && TSL.subscribe) TSL.subscribe(this.querySelector('input[type=email]').value, 'Footer');
    this.innerHTML = '<div style="font-size:14px">Thanks — welcome to the club.</div>';
  });
  $$('.facc__btn').forEach(function (b) {
    b.addEventListener('click', function () { b.parentElement.classList.toggle('is-open'); });
  });

  /* ---------------------------------------------------------
     MOBILE NAV
  --------------------------------------------------------- */
  var MQUICK = [['Shop All', 'all'], ['New In', 'new'], ['Best Sellers', 'best'], ['Customer Favorites', 'page:customer-favorites'], ['Sets', 'sets'], ['Après Surf', 'accessories']];
  var MNAV = [
    { t: 'By category', links: [['Beach Tunics', 'beach-shirt'], ['Dresses', 'dresses'], ['Tanks & Tops', 'landon'],
      ['Pants', 'pants'], ['Shorts', 'asher'], ['Skirts', 'bridgett']] },
    { t: 'Collections', links: [['The Shea', 'shea'], ['Matching Sets', 'sets'], ['Resort 26', 'new'],
      ['Après Surf', 'accessories'], ['Shop the Passport Issue', 'passport']] },
    { t: 'Dresses', links: [['All Dresses', 'dresses'], ['Short sleeve', 'shea-ss'], ['Long sleeve', 'shea-ls']] },
    { t: 'Sets', links: [['All Sets', 'sets'], ['The Button-Up Beach Tunic', 'beach-shirt'], ['The Kaitlin Pants', 'kaitlin'],
      ['The Asher Shorts', 'asher'], ['The Bridgett Skirt', 'bridgett'], ['The New Landon Tank', 'landon']] }
  ];
  $('#mnavBody').innerHTML =
    '<div class="mnav__quick">' + MQUICK.map(function (l) {
      if (l[1].indexOf('page:') === 0) return '<a href="#" data-page="' + l[1].slice(5) + '">' + l[0] + '</a>';
      return '<a href="#" data-collection="' + l[1] + '">' + l[0] + '</a>';
    }).join('') + '</div>' +
    MNAV.map(function (g) {
      return '<div class="macc"><button class="macc__btn">' + g.t +
        '<svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="1.6"><path d="M6 9l6 6 6-6"/></svg></button>' +
        '<div class="macc__panel">' + g.links.map(function (l) {
          return '<a href="#" data-collection="' + l[1] + '">' + l[0] + '</a>';
        }).join('') + '</div></div>';
    }).join('');
  $$('#mnavBody .macc__btn').forEach(function (b) {
    b.addEventListener('click', function () { b.parentElement.classList.toggle('is-open'); });
  });
  $('#burger').addEventListener('click', function () { open('#mnav'); });

  /* ---------------------------------------------------------
     SIZE GUIDE DRAWER
  --------------------------------------------------------- */
  function tableHTML(t) {
    return '<table class="sizet"><thead><tr>' + t.cols.map(function (c) { return '<th>' + szText(c) + '</th>'; }).join('') + '</tr></thead><tbody>' +
      t.rows.map(function (r) { return '<tr>' + r.map(function (c, i) { return (i === 0 ? '<th>' : '<td>') + (i === 0 ? szText(c) : c) + (i === 0 ? '</th>' : '</td>'); }).join('') + '</tr>'; }).join('') +
      '</tbody></table>';
  }
  function openSizeGuide(style) {
    $('#sizeBody').innerHTML = sizeGuideHTML(style);
    open('#sizeDrawer');
  }
  function sizeGuideHTML(style) {
    var body = FIT.body;
    var html = '<div class="sizeg__intro">Sized 0 to 3. Measurements are in inches.</div>';
    if (style && FIT[style]) {
      var f = FIT[style];
      html += '<h4>' + f.label + ' — garment measurements</h4><p class="sizeg__note">' + f.note + '</p>' + tableHTML(f);
    }
    html += '<h4>Body measurements</h4><p class="sizeg__note">' + body.note + '</p>' + tableHTML(body);
    if (!style) {
      html += '<h4>Fit notes by style</h4><ul class="sizeg__list">' + Object.keys(FIT).filter(function (k) { return k !== 'body'; }).map(function (k) {
        return '<li><b>' + FIT[k].label + '</b> — ' + FIT[k].note + '</li>';
      }).join('') + '</ul>';
    }
    html += '<div class="sizeg__intro" style="margin-top:22px">Still unsure? Write to us and we will help you pick — exchanges are free within 14 days.</div>';
    return html;
  }

  /* ---------------------------------------------------------
     ROUTED VIEWS — product pages + collection pages
  --------------------------------------------------------- */
  var COPY = {
    'all': 'Every piece currently in stock, cut from eco rayon and 100% bamboo.',
    'new': 'The latest additions to the line: the Search for Surf Tour Sweatshirt, The Travel T and The Shea Long Sleeve T-Shirt Dress in white.',
    'best': 'The styles our customers reorder most, led by The Shea T-Shirt Dress in white.',
    'sets': 'Shirt, short, pant and skirt combinations designed to be worn together or split apart.',
    'passport': 'The four pieces styled in this week\u2019s Passport issue — St. Barths, where the dress code is French and the shoes are always flat.',
    'shea': 'The dress that started it all, cut in 100% bamboo — soft, stretchy and breathable, with a high side slit. Buy two Shea dresses, save 10%.',
    'shea-ss': 'The original short-sleeve Shea in 100% bamboo.',
    'shea-ls': 'The Shea with sleeves — the same bamboo, cut for cooler evenings.',
    'beach-shirt': 'The over-everything layer. Open over a swimsuit at ten, sleeves rolled at the dinner table by eight.',
    'kaitlin': 'High-waisted, wide-leg pants that read as one considered outfit with almost anything on top.',
    'asher': 'Soft pull-on shorts for the walk between the water and lunch.',
    'bridgett': 'The maxi skirt with the slit — over a swimsuit on the sand, tucked with a plain tee for dinner.',
    'landon': 'The fitted tank that anchors a set or stands alone under everything else.',
    'vacation': 'The relaxed white pant made for long lunches and longer flights.',
    'pants': 'The Kaitlin and the Vacation Pant — two ways to travel in long trousers.',
    'dresses': 'Weightless bamboo dresses cut to be thrown on over a swimsuit and worn straight through to dinner.',
    'tops': 'Beach tunics and tanks in breathable natural fabrics.',
    'bottoms': 'Pants, shorts and skirts made to move from sand to street.',
    'accessories': 'For the days that start at the beach and end wherever the sun takes you.'
  };
  var TITLES = {
    'all': 'Shop All', 'new': 'New Arrivals', 'best': 'Best Sellers', 'sets': 'Matching Sets',
    'passport': 'Shop the Passport Issue', 'shea': 'The Shea', 'shea-ss': 'The Shea — Short Sleeve', 'shea-ls': 'The Shea — Long Sleeve',
    'beach-shirt': 'Beach Tunics', 'kaitlin': 'The Kaitlin Pants', 'asher': 'Shorts', 'bridgett': 'Skirts',
    'landon': 'Tanks & Tops', 'vacation': 'The Vacation Pant', 'pants': 'Pants', 'dresses': 'Dresses',
    'tops': 'Tops & Beach Tunics', 'bottoms': 'Pants, Shorts & Skirts', 'accessories': 'Après Surf'
  };
  var COLLIMG = {
    'all': ['//thisistheshoreline.com/cdn/shop/t/16/assets/life-07.jpg?v=44774578320962163341792638983', '50% 40%'], 'new': ['//thisistheshoreline.com/cdn/shop/t/16/assets/pd-shea-ls-w-1.jpg?v=158653971055562228241792638984', '50% 30%'],
    'best': ['//thisistheshoreline.com/cdn/shop/t/16/assets/life-10.jpg?v=60497788183781372301792638983', '50% 40%'], 'sets': ['//thisistheshoreline.com/cdn/shop/t/16/assets/life-14.jpg?v=89096995320157011041792638984', '50% 40%'],
    'passport': ['//thisistheshoreline.com/cdn/shop/t/16/assets/life-11.jpg?v=95492846321704186351792638983', '50% 40%'], 'shea': ['//thisistheshoreline.com/cdn/shop/t/16/assets/life-09.jpg?v=46357285430138059091792638982', '50% 40%'],
    'dresses': ['//thisistheshoreline.com/cdn/shop/t/16/assets/life-09.jpg?v=46357285430138059091792638982', '50% 40%'], 'beach-shirt': ['//thisistheshoreline.com/cdn/shop/t/16/assets/life-04.jpg?v=71150433294772170111792638983', '50% 40%'],
    'accessories': ['//thisistheshoreline.com/cdn/shop/t/16/assets/apres-2.jpg?v=29417851539269756441792638949', '50% 30%'], 'pants': ['//thisistheshoreline.com/cdn/shop/t/16/assets/life-16.jpg?v=154963515659246373581792638984', '50% 40%']
  };
  function collectionFor(key) { return SETS[key] || P; }

  var activeView = null;
  function showView(id) {
    $$('.view').forEach(function (v) { if ('#' + v.id !== id) v.classList.remove('is-on'); });
    closeMega();
    activeView = id;
    $('#home').style.display = 'none';
    $(id).classList.add('is-on');
    document.body.classList.add('has-view');
    if (!/#./.test(location.hash)) window.scrollTo(0, 0);
  }
  function hideViews() {
    $$('.view').forEach(function (v) { v.classList.remove('is-on'); });
    activeView = null;
    $('#home').style.display = '';
    document.body.classList.remove('has-view');
    $('#stickyAtc').classList.remove('is-on');
    document.body.classList.remove('has-sticky');
  }

  /* ---------- PDP ---------- */
  var stickyIO = null;
  function galleryHTML(p, D) {
    var imgs = (D.imgs && D.imgs.length) ? D.imgs : [{ src: p.img, w: 3, h: 4 }, { src: p.img2, w: 3, h: 4 }];
    // desktop shows every photo at its own proportions; mobile shows only even 3:4 frames
    var fit = function (im) { return Math.abs(im.w / im.h - 0.75) <= 0.02; };
    var nGood = imgs.filter(fit).length, extraLeft = Math.max(0, 3 - nGood);
    return imgs.map(function (im, i) {
      var wide = im.w > im.h * 1.05;
      var cls = '';
      if (!fit(im)) {
        var r = im.w / im.h;
        if (extraLeft > 0 && r > 0.6 && r < 0.9) { cls = ' is-contain'; extraLeft--; } else cls = ' is-off';
      }
      return '<figure class="pdp__shot' + (wide ? ' is-wide' : '') + cls + '"' + (wide ? ' style="aspect-ratio:' + im.w + '/' + im.h + '"' : '') + '>' +
        '<img src="' + im.src + '" alt="' + esc(p.title) + ' — ' + esc(p.color) + (i ? ' view ' + (i + 1) : '') + '"' + (i > 1 ? ' loading="lazy"' : '') + '></figure>';
    }).join('');
  }
  function chartHTML(c) {
    return '<table class="sizet"><thead><tr>' + c.cols.map(function (h) { return '<th>' + esc(szText(h)) + '</th>'; }).join('') + '</tr></thead><tbody>' +
      c.rows.map(function (r) { return '<tr>' + r.map(function (v, i) { return i ? '<td>' + esc(v) + '</td>' : '<th>' + esc(szText(v)) + '</th>'; }).join('') + '</tr>'; }).join('') +
      '</tbody></table>';
  }
  // a short 5-star quote in the right-hand column, linking down to all reviews
  function reviewQuoteHTML(p, rv) {
    if (!rv || !rv.count || !rv.reviews || !rv.reviews.length) return '';
    var pool = rv.reviews.filter(function (r) { return r.r >= 5 && r.b && r.b.length <= 240; });
    if (!pool.length) pool = rv.reviews.filter(function (r) { return r.r >= 4 && r.b; });
    if (!pool.length) return '';
    var r = pool.slice().sort(function (a, b) { return (b.d || '').localeCompare(a.d || ''); })[0];
    var body = r.b.length > 240 ? r.b.slice(0, 236).replace(/\s+\S*$/, '') + '\u2026' : r.b;
    return '<div class="revq">' +
      '<div class="revq__head"><p class="cts__eyebrow">What customers say</p>' +
      '<a href="products/' + p.handle + '#pdpReviews" data-toreviews>' + starsHTML(rv.avg) + ' <b>' + rv.avg.toFixed(1) + '</b> &middot; ' + rv.count + ' review' + (rv.count > 1 ? 's' : '') + '</a></div>' +
      '<blockquote class="revq__body">' + (r.t ? '<b>' + esc(r.t) + '</b> ' : '') + esc(body) + '</blockquote>' +
      '<div class="revq__foot"><span>' + esc(r.a) + ' &middot; Verified buyer</span>' +
      '<a href="products/' + p.handle + '#pdpReviews" class="revq__all" data-toreviews>Read all reviews</a></div>' +
      '</div>';
  }
  function lookBlockHTML(p) {
    var pcs = lookOf(p);
    if (!pcs.length) return '';
    return '<div class="ctl" id="lookBox">' +
      '<div class="ctl__head"><p class="cts__eyebrow">Complete the look</p><span>' + (pcs.length > 1 ? 'The rest of the set' : 'The matching piece') + '</span></div>' +
      pcs.map(function (x) {
        return '<div class="ctl__item" data-lookh="' + x.handle + '">' +
          '<a href="#" class="ctl__img" data-go="' + x.handle + '"><img src="' + x.img + '" alt="' + esc(x.title) + ' \u2014 ' + esc(x.color) + '"></a>' +
          '<div class="ctl__info">' +
          '<a href="#" class="ctl__name" data-go="' + x.handle + '">' + esc(x.title) + '</a>' +
          '<span class="ctl__meta">' + esc(x.color) + ' &middot; ' + money(x.price) + '</span>' +
          '<div class="ctl__row"><div class="cts__sizes">' + chipRow(x, 'data-looksize') + '</div>' +
          '<button class="ctl__add" data-lookadd="' + x.handle + '" aria-label="Add ' + esc(x.title) + '">Add</button></div>' +
          '</div></div>';
      }).join('') +
      (pcs.length >= 2 ? '<button class="btn btn--outline btn--block ctl__all" id="lookAll">Add the full look</button>' : '') +
      '<p class="cts__error" id="lookErr" hidden></p>' +
      '</div>';
  }
  function pairBlockHTML(p) {
    var sec, eyebrow, offer, btn, note, label;
    if (!isShea(p)) return '';
    if (isShea(p)) {
      sec = sheaSecond(p);
      if (!sec) return '';
      var pair = p.price + sec.price;
      eyebrow = 'Buy two Shea dresses, save 10%';
      offer = '<s>' + money(pair) + '</s> <b>' + money(r2(pair * 0.9)) + '</b> for both';
      btn = 'Add both, save 10%';
      label = 'Size for your second dress';
      note = 'Mix any colors or sizes. 10% off applies automatically in your cart when you have two or more Shea dresses, short or long sleeve.';
    } else {
      sec = partnersOf(p)[0];
      if (!sec) return '';
      eyebrow = 'Complete the set';
      offer = 'The full look: ' + money(p.price + sec.price);
      btn = 'Add both to cart';
      label = 'Size for ' + sec.title.replace(/^The /, 'the ');
      note = 'Made to match. Wear together or apart.';
    }
    return '<div class="cts" id="pairBox" data-second="' + sec.handle + '">' +
      '<p class="cts__eyebrow">' + eyebrow + '</p>' +
      '<div class="cts__row">' +
      '  <a href="#" class="cts__media" data-go="' + sec.handle + '"><img src="' + sec.img + '" alt="' + esc(sec.title) + ' \u2014 ' + esc(sec.color) + '"></a>' +
      '  <div class="cts__info">' +
      '    <a href="#" class="cts__title" data-go="' + sec.handle + '">' + esc(sec.title) + ' \u2014 ' + esc(sec.color) + '</a>' +
      '    <p class="cts__price">' + money(sec.price) + '</p>' +
      '    <p class="cts__offer">' + offer + '</p>' +
      '    <p class="cts__label">' + esc(label) + '</p>' +
      '    <div class="cts__sizes">' + chipRow(sec, 'data-pairsize') + '</div>' +
      '    <button type="button" class="btn btn--outline btn--block cts__button" id="pairAdd">' + btn + '</button>' +
      '    <p class="cts__error" id="pairErr" hidden></p>' +
      '  </div>' +
      '</div>' +
      '<p class="cts__note">' + note + '</p>' +
      '</div>';
  }
  function renderPDP(handle) {
    var p = byHandle(handle);
    if (!p) return false;
    var fit = FIT[p.style] || (p.style === 'apres-sweatshirt' ? { fit: 62, note: 'Unisex sizing for a relaxed, easy fit. Size down for a more fitted look.' } : p.style === 'travel-t' ? { fit: 58, note: 'Relaxed, roomy fit, slightly cropped to hit at the waistband of the Kaitlin Pants.' } : { fit: 50, note: 'True to size.' });
    var sizes = sizeNames(p).map(function (sz) {
      var ok = sizeState(p, sz);
      return ok
        ? '<button data-pdpsize="' + sz + '">' + szChip(sz) + '</button>'
        : '<button class="is-out" data-notify="' + sz + '" title="Notify me when back">' + szChip(sz) + '<i>✉</i></button>';
    }).join('');
    var cws = colorways(p);
    var catKey = STYLE_KEY[p.style] || 'all';
    var cat = STYLE_LABEL[p.style] || 'Shop';
    var rv = RV[p.title];
    var D = (window.PDP || {})[p.handle] || { desc: '', fabric: '', chart: null, imgs: [], care: [] };
    $('#pdpBody').innerHTML = '' +
      '<div class="pdp__backbar"><a href="#" class="pdp__back" data-back="' + catKey + '" aria-label="Back">' +
      '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M15 5l-7 7 7 7"/></svg><span>Back</span></a></div>' +
      '<div class="pdp">' +
      '  <div class="pdp__gallery">' + galleryHTML(p, D) + '</div>' +
      '  <div class="pdp__panel">' +
      '    <div class="crumbs crumbs--pdp"><a href="#" data-home>Home</a> / <a href="#" data-collection="' + catKey + '">' + cat + '</a> / <span>' + esc(p.title) + ' — ' + esc(p.color) + '</span></div>' +
      (p.badge ? '<div class="pdp__badge">' + p.badge + '</div>' : '') +
      '    <h1>' + esc(p.title) + ' — ' + esc(p.color) + '</h1>' +
      '    <div class="pdp__price">' + money(p.price) + ' USD</div>' +
      (isShea(p) ? '    <div class="pdp__promo">Buy two Shea dresses, save 10%</div>' : '') +
      (rv && rv.count
        ? '<a href="products/' + p.handle + '#pdpReviews" class="pdp__stars" data-toreviews>' + starsHTML(rv.avg) +
          '<b>' + rv.avg.toFixed(1) + '</b><span>Read ' + rv.count + ' review' + (rv.count > 1 ? 's' : '') + '</span></a>'
        : '') +
      '    <div class="pdp__label" style="margin-top:22px"><span>Color · ' + esc(p.color) + '</span></div>' +
      '    <div class="pdp__colors">' + cws.map(function (c) {
        return '<a href="#" class="pdp__cw' + (c.handle === p.handle ? ' is-on' : '') + '" data-colorway="' + c.handle + '" title="' + esc(c.color) + '">' +
          '<img src="' + c.img + '" alt="' + esc(c.color) + '"' + (c.pos ? ' style="object-position:' + c.pos + '"' : '') + '></a>';
      }).join('') + '</div>' +
      '    <div class="pdp__sizes">' +
      '      <div class="pdp__label"><span>Size</span>' + (p.style === 'apres-sweatshirt' ? '<span>Unisex S–L</span>' : '<a href="#" data-sizeguide="' + p.style + '">Size guide</a>') + '</div>' +
      '      <div class="pdp__sizegrid">' + sizes + '</div>' +
      '      <div class="pdp__tip" id="pdpTip">Please select a size</div>' +
      '    </div>' +
      '    <div class="fitbar"><span>Runs small</span><i><b style="left:' + fit.fit + '%"></b></i><span>Runs large</span></div>' +
      '    <div class="fitbar__note">' + fit.note + '</div>' +
      '    <div class="pdp__add">' +
      '      <button class="btn btn--dark btn--block" id="pdpAdd" data-handle="' + p.handle + '">Add to cart</button>' +
      '      <button class="btn btn--outline btn--block" data-wish="' + p.handle + '">' + (inWish(p.handle) ? 'Saved to wishlist' : 'Add to wishlist') + '</button>' +
      '    </div>' +
      pairBlockHTML(p) +
      '    <div class="trustbox">' +
      '      <div><svg viewBox="0 0 24 24"><path d="M3 7h11v9H3zM14 10h4l3 3v3h-7z"/><circle cx="7" cy="18" r="1.6"/><circle cx="17" cy="18" r="1.6"/></svg>Fast shipping — orders leave within 1 to 2 business days</div>' +
      '      <div><svg viewBox="0 0 24 24"><circle cx="12" cy="12" r="9"/><path d="M3 12h18M12 3c3 3.5 3 14 0 18M12 3c-3 3.5-3 14 0 18"/></svg>Free shipping on every order, always</div>' +
      '      <div><svg viewBox="0 0 24 24"><path d="M4 8h16M8 4l-4 4 4 4"/><path d="M20 16H4M16 12l4 4-4 4"/></svg>Easy 14-day returns &amp; exchanges</div>' +
      '    </div>' +
        reviewQuoteHTML(p, rv) +
        lookBlockHTML(p) +
      '    <div class="pdp__acc">' +
      '      <details open><summary>Description</summary><div class="pdp__rich">' + (szDesc(D.desc) || '<p>' + esc(p.title) + ' in ' + esc(p.color.toLowerCase()) + '.</p>') + '</div></details>' +
      (D.fabric ? '      <details><summary>Fabric content</summary><div class="pdp__rich">' + D.fabric + '</div></details>' : '') +
      (D.care && D.care.length ? '      <details><summary>Care</summary><div class="pdp__rich"><ul>' + D.care.map(function (c) { return '<li>' + esc(c) + '</li>'; }).join('') + '</ul></div></details>' : '') +
      (D.chart ? '      <details><summary>Size chart</summary><div class="pdp__rich">' + chartHTML(D.chart) + '<p class="pdp__small">Garment measurements in inches. <a href="#" data-sizeguide="' + p.style + '">Full size guide</a></p></div></details>' : '') +
      '      <details><summary>Shipping &amp; returns</summary>' +
      '        <p>Shipping is free on every order, always, with no minimum spend. Orders leave within 1 to 2 business days and arrive in 3 to 5. We accept returns for exchange, store credit or refund on full-price items within 14 days of delivery — pieces must be new, unworn and unwashed with tags attached. We ship within the United States.</p></details>' +
      '      <details><summary>FAQ</summary>' +
      '        <p><b>Between sizes?</b> Size up for more drape, size down for a closer fit.<br><b>Is the Passport free?</b> Yes — Destination of the Week, Travel Journal and Style Inspiration are open to everyone.<br><b>Can I exchange?</b> Yes, within 14 days of delivery.</p></details>' +
      '    </div>' +
      '  </div>' +
      '</div>';

    var picked = null;
    function markSize() {
      $$('#pdpBody [data-pdpsize]').forEach(function (b) {
        b.classList.toggle('is-on', b.getAttribute('data-pdpsize') === picked);
      });
      $('#pdpTip').classList.remove('is-on');
    }
    $$('#pdpBody [data-pdpsize]').forEach(function (b) {
      b.addEventListener('click', function (e) { e.preventDefault(); picked = b.getAttribute('data-pdpsize'); markSize(); });
    });
    $$('#pdpBody [data-notify]').forEach(function (b) {
      b.addEventListener('click', function (e) {
        e.preventDefault();
        if (window.TSL && TSL.notify && TSL.notify(p, b.getAttribute('data-notify'))) return;
        toast('We\u2019ll email you when size ' + szText(b.getAttribute('data-notify')) + ' is back');
      });
    });
    function tryAdd() {
      if (!picked) {
        $('#pdpTip').classList.add('is-on');
        var g = $('#pdpBody .pdp__sizegrid');
        g.classList.remove('is-shake'); void g.offsetWidth; g.classList.add('is-shake');
        g.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }
      addToCart(p.handle, picked);
    }
    $('#pdpAdd').addEventListener('click', tryAdd);
    var lookPick = {};
    $$('#pdpBody [data-looksize]').forEach(function (b) {
      b.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation();
        var h = b.getAttribute('data-looksize');
        lookPick[h] = b.getAttribute('data-size');
        $$('#pdpBody [data-looksize="' + h + '"]').forEach(function (x) { x.classList.toggle('is-on', x === b); });
        $('#lookErr').hidden = true;
        lookTotal();
      });
    });
    $$('#pdpBody [data-lookadd]').forEach(function (b) {
      b.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation();
        var h = b.getAttribute('data-lookadd');
        if (!lookPick[h]) {
          $('#lookErr').textContent = 'Choose a size for ' + byHandle(h).title.replace(/^The /, 'the ') + '.'; $('#lookErr').hidden = false;
          var row = b.closest('.ctl__item').querySelector('.cts__sizes');
          row.classList.remove('is-shake'); void row.offsetWidth; row.classList.add('is-shake');
          return;
        }
        addToCart(h, lookPick[h]);
      });
    });
    function lookTotal() {
      var b = $('#lookAll'); if (!b) return;
      var chosen = lookOf(p).filter(function (x) { return lookPick[x.handle]; });
      b.textContent = chosen.length
        ? 'Add the look \u00b7 ' + (chosen.length + 1) + ' pieces \u00b7 ' + money(p.price + chosen.reduce(function (n, x) { return n + x.price; }, 0))
        : 'Add the full look';
    }
    if ($('#lookAll')) $('#lookAll').addEventListener('click', function () {
      var err = $('#lookErr');
      if (!picked) {
        err.textContent = 'Choose your size for this piece above first.'; err.hidden = false;
        var g = $('#pdpBody .pdp__sizegrid'); g.classList.remove('is-shake'); void g.offsetWidth; g.classList.add('is-shake');
        $('#pdpTip').classList.add('is-on');
        return;
      }
      var chosen = lookOf(p).filter(function (x) { return lookPick[x.handle]; });
      if (!chosen.length) {
        err.textContent = 'Choose a size for each piece you want in the look.'; err.hidden = false;
        $$('#pdpBody .ctl__item .cts__sizes').forEach(function (r) { r.classList.remove('is-shake'); void r.offsetWidth; r.classList.add('is-shake'); });
        return;
      }
      err.hidden = true;
      addMany([{ h: p.handle, s: picked }].concat(chosen.map(function (x) { return { h: x.handle, s: lookPick[x.handle] }; })));
    });
    var pairPick = null;
    $$('#pdpBody [data-pairsize]').forEach(function (b) {
      b.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation();
        pairPick = b.getAttribute('data-size');
        $$('#pdpBody [data-pairsize]').forEach(function (x) { x.classList.toggle('is-on', x === b); });
        $('#pairErr').hidden = true;
      });
    });
    if ($('#pairAdd')) $('#pairAdd').addEventListener('click', function () {
      var err = $('#pairErr');
      if (!picked) {
        err.textContent = 'Please choose a size above first.'; err.hidden = false;
        $('#pdpTip').classList.add('is-on');
        var g = $('#pdpBody .pdp__sizegrid');
        g.classList.remove('is-shake'); void g.offsetWidth; g.classList.add('is-shake');
        return;
      }
      if (!pairPick) {
        err.textContent = 'Please choose a size for the second item.'; err.hidden = false;
        var g2 = $('#pdpBody .cts__sizes');
        g2.classList.remove('is-shake'); void g2.offsetWidth; g2.classList.add('is-shake');
        return;
      }
      err.hidden = true;
      addMany([{ h: p.handle, s: picked }, { h: $('#pairBox').getAttribute('data-second'), s: pairPick }]);
    });
    $('#stickyAdd').onclick = tryAdd;
    $$('#pdpBody [data-colorway]').forEach(function (a) {
      a.addEventListener('click', function (e) { e.preventDefault(); go('#/product/' + a.getAttribute('data-colorway')); });
    });
    $$('#pdpBody [data-home]').forEach(function (a) {
      a.addEventListener('click', function (e) { e.preventDefault(); go(''); });
    });
    $$('#pdpBody [data-toreviews]').forEach(function (a) {
      a.addEventListener('click', function (e) { e.preventDefault(); $('#pdpReviews').scrollIntoView({ behavior: 'smooth' }); });
    });

    // sticky add-to-cart bar
    $('#stickyImg').src = p.img;
    $('#stickyName').textContent = p.title + ' — ' + p.color;
    $('#stickyPrice').textContent = money(p.price);
    if (stickyIO) stickyIO.disconnect();
    $('#stickyAtc').classList.remove('is-on');
    if ('IntersectionObserver' in window) {
      stickyIO = new IntersectionObserver(function (rows) {
        var r = rows[0];
        var below = !r.isIntersecting && r.boundingClientRect.top < 0;
        $('#stickyAtc').classList.toggle('is-on', below);
        document.body.classList.toggle('has-sticky', below);
      }, { root: null, threshold: 0 });
      stickyIO.observe($('#pdpAdd'));
    }

    // rails
    var others = [];
    function okR(x) { return x.title !== p.title && inStock(x) && others.indexOf(x) === -1; }
    partnersOf(p).forEach(function (x) { if (okR(x)) others.push(x); });
    P.forEach(function (x) { if (x.color === p.color && okR(x)) others.push(x); });
    SETS.best.forEach(function (x) { if (okR(x)) others.push(x); });
    P.forEach(function (x) { if (okR(x)) others.push(x); });
    var seenR = {};
    others = others.filter(function (x) { var k = x.title + x.color; if (seenR[x.title] >= 2) return false; seenR[x.title] = (seenR[x.title] || 0) + 1; return true; });
    $('#pdpRailTrack').innerHTML = others.slice(0, 10).map(cardHTML).join('');
    var rec = recent.filter(function (h) { return h !== handle; }).map(byHandle).filter(Boolean);
    $('#pdpRecent').style.display = rec.length ? '' : 'none';
    $('#pdpRecentTrack').innerHTML = rec.map(cardHTML).join('');
    recent = [handle].concat(recent.filter(function (h) { return h !== handle; })).slice(0, 8);
    if (window.TSL) TSL.save('recent', recent);
    $$('#pdpView .rail').forEach(updateArrows);
    renderReviews(p);
    document.title = p.title + ' — ' + p.color + ' — THE SHORE LINE';
    return true;
  }

  /* ---------- COLLECTION + FILTERS ---------- */
  var FILT = { sort: 'featured', size: [], color: [], style: [] };
  var collKey = 'all', collPage = 1, PER_PAGE = 12;
  function resetFilt() { FILT = { sort: 'featured', size: [], color: [], style: [] }; }
  function filtCount() { return FILT.size.length + FILT.color.length + FILT.style.length + (FILT.sort !== 'featured' ? 1 : 0); }
  function applyFilt(list) {
    var out = list.filter(function (p) {
      if (FILT.color.length && FILT.color.indexOf(p.color) === -1) return false;
      if (FILT.style.length && FILT.style.indexOf(p.style) === -1) return false;
      if (FILT.size.length && !FILT.size.some(function (s) { return sizeState(p, s); })) return false;
      return true;
    });
    if (FILT.sort === 'price-asc') out.sort(function (a, b) { return a.price - b.price; });
    else if (FILT.sort === 'price-desc') out.sort(function (a, b) { return b.price - a.price; });
    else if (FILT.sort === 'az') out.sort(function (a, b) { return (a.title + a.color).localeCompare(b.title + b.color); });
    return out;
  }
  function renderCollectionGrid() {
    var base = collectionFor(collKey);
    var list = applyFilt(base);
    var shown = list; // show every item — no load more
    var html = '';
    var lookI = 0;
    shown.forEach(function (p, i) {
      html += cardHTML(p);
    });
    if (!list.length) {
      html = '<div class="collempty">' +
        (collKey === 'accessories'
          ? '<img src="//thisistheshoreline.com/cdn/shop/t/16/assets/apres-2.jpg?v=29417851539269756441792638949" alt="Après Surf" style="display:block;width:100%;max-height:520px;object-fit:cover;object-position:50% 30%;margin-bottom:22px;border-radius:var(--radius)">' +
            '<p>The next Après Surf drop is in production. Nothing is listed yet — join the list and we will let you know the moment it lands.</p>' +
            '<div style="display:flex;gap:10px;flex-wrap:wrap"><a href="#club" class="btn btn--dark" data-scroll="#club">Join the waitlist</a><a href="#" class="btn btn--outline" data-collection="new">Shop New Arrivals</a></div>'
          : base.length
            ? '<p>Nothing matches these filters.</p><button class="btn btn--outline" id="collClear">Clear filters</button>'
            : '<p>Nothing in this collection is in stock right now. It will return for the season.</p>') +
        '</div>';
    }
    $('#collGrid').innerHTML = html;
    var cc = $('#collClear');
    if (cc) cc.addEventListener('click', function () { resetFilt(); collPage = 1; renderCollectionGrid(); });
    $('#collCount').textContent = list.length
      ? list.length + ' piece' + (list.length > 1 ? 's' : '')
      : (collKey === 'accessories' ? 'Coming soon' : '');
    var n = filtCount();
    $('#filtCount').textContent = n ? n : '';
    renderWish();
  }
  function renderCollection(key, query) {
    var q = {};
    (query || '').split('&').forEach(function (kv) {
      if (!kv) return;
      var a = kv.split('=');
      q[decodeURIComponent(a[0])] = decodeURIComponent(a[1] || '');
    });
    if (key !== collKey) resetFilt();
    if (q.color) FILT.color = [q.color];
    collKey = key; collPage = 1;
    var title = TITLES[key] || 'Shop All';
    var im = COLLIMG[key] || COLLIMG.all;
    var list = collectionFor(key);
    if (!COLLIMG[key] && list[0]) im = [list[0].img, list[0].pos || '50% 30%'];
    $('#collTitle').textContent = title;
    $('#collDesc').textContent = COPY[key] || COPY.all;
    var panes = [], seenSrc = {};
    function addPane(src) { if (src && !seenSrc[src] && panes.length < 4) { seenSrc[src] = 1; panes.push(src); } }
    // lifestyle banner images are landscape — use only 3:4 product shots so nothing is cropped
    var seenStyleB = {};
    list.forEach(function (x) { if (!seenStyleB[x.style + x.color]) { seenStyleB[x.style + x.color] = 1; addPane(x.img); } });
    list.forEach(function (x) { addPane(x.img2); });
    var isApres = key === 'accessories';
    $('#collBanStrip').closest('.collban').classList.toggle('is-video', isApres);
    $('#collView').classList.toggle('is-apres', isApres);
    $('#collBanStrip').innerHTML = isApres
      ? '<video class="apresvid__d" src="//thisistheshoreline.com/cdn/shop/t/16/assets/apres-desktop-16x9.mp4?v=174113852121457956591792638949" poster="//thisistheshoreline.com/cdn/shop/t/16/assets/apres-desktop-poster.jpg?v=57410532300394281841792638983" autoplay muted loop playsinline aria-label="Après Surf, Après Sea, Après Shore"></video>' +
        '<video class="apresvid__m" src="//thisistheshoreline.com/cdn/shop/t/16/assets/apres-mobile-4x5.mp4?v=5470022339245900451792638983" poster="//thisistheshoreline.com/cdn/shop/t/16/assets/apres-mobile-poster.jpg?v=93352012317587079311792638983" autoplay muted loop playsinline aria-label="Après Surf, Après Sea, Après Shore"></video>'
      : panes.map(function (src) { return '<div class="collban__pane"><img src="' + src + '" alt=""></div>'; }).join('');
    $('#collBanStrip').setAttribute('data-n', isApres ? 1 : panes.length);
    $('#collCrumb').innerHTML = '<a href="#" data-home>Home</a> / <a href="#" data-collection="all">Collections</a> / <span>' + title + '</span>';
    $$('#collCrumb [data-home]').forEach(function (a) {
      a.addEventListener('click', function (e) { e.preventDefault(); go(''); });
    });
    renderCollectionGrid();
    document.title = title + ' — THE SHORE LINE';
    return true;
  }
  // filter drawer
  function renderFilterDrawer() {
    var base = collectionFor(collKey);
    var colors = [], styles = [];
    base.forEach(function (p) {
      if (colors.indexOf(p.color) === -1) colors.push(p.color);
      if (styles.indexOf(p.style) === -1) styles.push(p.style);
    });
    var SORTS = [['featured', 'Featured'], ['price-asc', 'Price, low to high'], ['price-desc', 'Price, high to low'], ['az', 'Alphabetically, A–Z']];
    function chips(name, opts, labelFn) {
      return '<div class="filt__group"><h5>' + name + '</h5><div class="filt__chips">' + opts.map(function (o) {
        var val = typeof o === 'string' ? o : o[0];
        var lab = labelFn ? labelFn(o) : val;
        var key = name.toLowerCase();
        var on = key === 'sort' ? FILT.sort === val : FILT[key].indexOf(val) > -1;
        return '<button data-f="' + key + '" data-v="' + esc(val) + '"' + (on ? ' class="is-on"' : '') + '>' + lab + '</button>';
      }).join('') + '</div></div>';
    }
    $('#filtBody').innerHTML =
      chips('Sort', SORTS, function (o) { return o[1]; }) +
      chips('Size', ['XS', 'S', 'M', 'L'], szText) +
      chips('Color', colors) +
      chips('Style', styles, function (s) { return TITLES[s] || s; });
    $$('#filtBody [data-f]').forEach(function (b) {
      b.addEventListener('click', function () {
        var f = b.getAttribute('data-f'), v = b.getAttribute('data-v');
        if (f === 'sort') FILT.sort = v;
        else {
          var i = FILT[f].indexOf(v);
          if (i > -1) FILT[f].splice(i, 1); else FILT[f].push(v);
        }
        renderFilterDrawer();
      });
    });
  }
  $('#openFilter').addEventListener('click', function () { renderFilterDrawer(); open('#filterDrawer'); });
  $('#filtClear').addEventListener('click', function () { resetFilt(); renderFilterDrawer(); });
  $('#filtApply').addEventListener('click', function () { collPage = 1; renderCollectionGrid(); close('#filterDrawer'); window.scrollTo(0, 0); });

  function renderPage(key, q) {
    var pg = PAGES[key];
    if (!pg) return false;
    $('#pageView').className = 'view view--' + (pg.kind || 'doc') + ' is-on';
    $('#pageCrumb').innerHTML = '<a href="#" data-home>Home</a> / <span>' + pg.crumb + '</span>';
    $('#pageCrumb').style.display = pg.kind === 'story' ? 'none' : '';
    $('#pageBody').innerHTML = pg.html;
    if (key === 'customer-favorites') renderFavPage();
    if (key === 'size-guide') $('#sizePageBody').innerHTML = sizeGuideHTML('') +
      Object.keys(FIT).filter(function (k) { return k !== 'body'; }).map(function (k) {
        return '<h4>' + FIT[k].label + ' \u2014 garment measurements</h4><p class="sizeg__note">' + FIT[k].note + '</p>' + tableHTML(FIT[k]);
      }).join('');
    if (key === 'contact') {
      var t = /(?:^|&)topic=([^&]+)/.exec(q || '');
      if (t && $('#contactTopic')) $('#contactTopic').value = decodeURIComponent(t[1]);
      $('#contactForm').addEventListener('submit', function (e) {
        e.preventDefault();
        if (!this.checkValidity()) { this.reportValidity(); return; }
        if (window.TSL && TSL.contactSubmit) { this.querySelector('button[type=submit]').disabled = true; TSL.contactSubmit(this); return; }
        $('#contactOk').hidden = false; this.querySelector('button[type=submit]').disabled = true;
      });
    }
    document.title = pg.title + ' \u2014 THE SHORE LINE';
    return true;
  }
  function relPath() {
    var p = location.pathname;
    if (p.indexOf(ROOT_PATH) === 0) p = p.slice(ROOT_PATH.length);
    return p.replace(/index\.html$/, '').replace(/\.html$/, '').replace(/\/$/, '');
  }
  function pageKeyFor(rel) {
    var k = null;
    Object.keys(PAGES).forEach(function (key) { if (PAGES[key].path === rel) k = key; });
    return k;
  }
  var HOME_TITLE = 'THE SHORE LINE \u2014 Coastal Resortwear & Travel Essentials';
  function route() {
    // old #/product/… links keep working: rewrite to the real URL
    if (/^#\/(product|collection)\//.test(location.hash)) history.replaceState({}, '', ROOT + pathFor(location.hash));
    var rel = relPath(), q = location.search.replace(/^\?/, ''), m;
    if ((m = /^products\/([^\/]+)$/.exec(rel))) {
      if (renderPDP(m[1])) { showView('#pdpView'); renderWish(); return; }
    } else if ((m = /^collections\/([^\/]+)$/.exec(rel))) {
      var k = SLUG_INV[m[1]] || m[1];
      if (renderCollection(k, q)) { showView('#collView'); return; }
    } else if (rel) {
      var key = pageKeyFor(rel);
      if (key && renderPage(key, q)) { showView('#pageView'); scrollToAnchor(); return; }
    }
    hideViews();
    document.title = HOME_TITLE;
    scrollToAnchor();
  }
  function scrollToAnchor() {
    if (!/^#[a-z][\w-]*$/i.test(location.hash)) return;
    setTimeout(function () { var n = document.querySelector(location.hash); if (n) n.scrollIntoView({ behavior: 'smooth', block: 'start' }); }, 80);
  }
  window.addEventListener('popstate', route);
  function go(r, extra) {
    closeAll();
    var url = ROOT + pathFor(r) + (extra || '');
    if (window.TSL_LIVE && url.split('#')[0] !== location.href.split('#')[0]) { location.href = url; return; }
    if (url !== location.href) { history.pushState({ d: (history.state && history.state.d || 0) + 1 }, '', url); }
    route();
  }
  $('.header__logo').addEventListener('click', function (e) { e.preventDefault(); go(''); window.scrollTo({ top: 0, behavior: 'smooth' }); });

  /* ---------------------------------------------------------
     REVIEWS (real Judge.me data, grouped by style)
  --------------------------------------------------------- */
  function starsHTML(score, size) {
    var out = '<span class="stars"' + (size ? ' style="--s:' + size + 'px"' : '') + '>';
    for (var i = 1; i <= 5; i++) {
      out += '<svg class="' + (score >= i - 0.25 ? 's-on' : 's-off') + '" viewBox="0 0 24 24">' +
        '<path d="M12 2.5l2.9 6.2 6.6.8-4.8 4.6 1.2 6.6L12 17.6 6.1 20.7l1.2-6.6L2.5 9.5l6.6-.8z"/></svg>';
    }
    return out + '</span>';
  }
  function niceDate(d) {
    if (!d) return '';
    var p = d.split('-');
    if (p.length < 3) return d;
    var M = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    return M[+p[1] - 1] + ' ' + (+p[2]) + ', ' + p[0];
  }
  function renderReviews(p) {
    var host = $('#pdpReviews');
    var data = RV[p.title];
    if (!data || !data.count) {
      host.innerHTML = '<div class="reviews__head" style="padding-bottom:0"><div class="reviews__score">' +
        '<div class="reviews__title">Reviews</div>' +
        '<span>No reviews yet for this piece — yours would be the first.</span></div></div>' +
        '<div class="reviews__empty">Every review on our site is left by a verified customer after purchase.</div>';
      return;
    }
    var list = data.reviews || [];
    var buckets = [0, 0, 0, 0, 0];
    list.forEach(function (r) { buckets[Math.min(4, Math.max(0, Math.round(r.r) - 1))]++; });
    var maxB = Math.max.apply(null, buckets) || 1;
    var bars = '';
    for (var st = 5; st >= 1; st--) {
      var n = buckets[st - 1];
      bars += '<div class="reviews__bar"><span>' + st + ' star</span>' +
        '<i><b style="width:' + (n / maxB * 100) + '%"></b></i><span>' + n + '</span></div>';
    }
    host.innerHTML = '' +
      '<div class="reviews__head">' +
      '  <div class="reviews__score">' +
      '    <div class="reviews__title">Reviews</div>' +
      '    <b>' + data.avg.toFixed(2) + '</b>' +
      '    ' + starsHTML(data.avg) +
      '    <span>' + data.count + ' review' + (data.count > 1 ? 's' : '') + ' for ' + esc(p.title) + '</span>' +
      '  </div>' +
      '  <div class="reviews__bars">' + bars + '</div>' +
      '</div>' +
      '<div class="reviews__list">' +
      list.map(function (r) {
        var longBody = false; // show full review text
        return '<article class="revcard">' +
          '<div class="revcard__top">' + starsHTML(r.r) +
          '<span class="revcard__who">' + r.a + '</span>' +
          '<span class="revcard__ver">Verified buyer</span>' +
          '<span class="revcard__date">' + niceDate(r.d) + '</span></div>' +
          (r.t ? '<div class="revcard__ttl">' + r.t + '</div>' : '') +
          '<p class="revcard__body' + (longBody ? ' is-clamped' : '') + '">' + r.b + '</p>' +
          (longBody ? '<button class="revcard__more">Read full review</button>' : '') +
          '</article>';
      }).join('') +
      '</div>' +
      '';
    $$('#pdpReviews .revcard__more').forEach(function (b) {
      b.addEventListener('click', function () {
        var body = b.previousElementSibling;
        var clamped = body.classList.toggle('is-clamped');
        b.textContent = clamped ? 'Read full review' : 'Show less';
      });
    });
  }

  /* ---------------------------------------------------------
     CUSTOMER FAVORITES — in-stock pieces with 5-star reviews
  --------------------------------------------------------- */
  function bestReview(title, color) {
    var d = RV[title];
    if (!d || !d.reviews || !d.reviews.length) return null;
    var five = d.reviews.filter(function (r) { return r.r >= 5; });
    if (!five.length) return null;
    var col = (color || '').toLowerCase();
    var words = ['stripe', 'polka', 'black', 'white'];
    var clean = five.filter(function (r) {
      var t = (r.t + ' ' + r.b).toLowerCase();
      return !words.some(function (w) { return t.indexOf(w) > -1 && col.indexOf(w) === -1; });
    });
    var pool = clean.length ? clean : five;
    return pool.slice().sort(function (a, b) { return b.b.length - a.b.length; })[0];
  }
  function favQuoteHTML(r) {
    var quote = r.b.replace(/^★+\s*/, '');
    // show the first couple of sentences, then Read more
    var sent = quote.match(/[^.!?]+[.!?]+["')\]]*\s*|[^.!?]+$/g) || [quote];
    var head = '';
    for (var si = 0; si < sent.length && (si < 2 || head.length < 110); si++) head += sent[si];
    head = head.trim();
    if (head.length > 230) head = quote.slice(0, 210).replace(/\s+\S*$/, '') + '\u2026';
    var long = quote.trim().length > 180 && head.length < quote.trim().length - 3;
    return (r.t ? '<b>' + r.t + '</b>' : '') +
      (long ? '      <span class="favcard__q favcard__q--short">' + head + '</span><span class="favcard__q favcard__q--full" hidden>' + quote + '</span>'
          : '      <span class="favcard__q">' + quote + '</span>') +
      (long ? '<button class="favcard__more" data-favmore>Read more</button>' : '');
  }
  function favCardHTML(p, r, agg, img) {
    return '<article class="favcard card" data-handle="' + p.handle + '">' +
      '  <div class="favcard__media card__media">' +
      '    <img src="' + (img || p.img) + '" alt="' + esc(p.title) + ' — ' + esc(p.color) + '" loading="lazy"' +
      (p.pos ? ' style="object-position:' + p.pos + '"' : '') + '>' +
      '  </div>' +
      '  <div class="favcard__body">' +
      '    <div class="favcard__name">' + esc(p.title) + '</div>' +
      '    <div class="favcard__meta">' + esc(p.color) + ' &middot; ' + money(p.price) + '</div>' +
      '    <div class="favcard__rate">' + starsHTML(5) +
      '      <span>' + agg.avg.toFixed(2) + ' average &middot; ' + agg.count + (agg.count === 1 ? ' review' : ' reviews') + '</span></div>' +
      '    <div class="favcard__quote">' + favQuoteHTML(r) +
      '      <div class="favcard__who">' + r.a + ' &middot; verified buyer</div>' +
      '    </div>' +
      '  </div>' +
      '</article>';
  }
  function wireFavMore(scope) {
    $$(scope + ' [data-favmore]').forEach(function (b) {
      b.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var sh = b.parentElement.querySelector('.favcard__q--short'), fu = b.parentElement.querySelector('.favcard__q--full');
        var open = fu.hidden;
        fu.hidden = !open; sh.hidden = open;
        b.textContent = open ? 'Show less' : 'Read more';
      });
    });
  }
  function renderFavs() {
    var host = $('#favsGrid');
    if (!host) return;
    var seenStyle = {};
    var cards = [];
    ['shea', 'beach-shirt', 'kaitlin', 'bridgett', 'asher', 'landon'].forEach(function (st) {
      (SETS[st] || []).forEach(function (p) {
        if (seenStyle[st]) return;
        var r = bestReview(p.title, p.color);
        if (!r) return;
        seenStyle[st] = 1;
        cards.push({ p: p, r: r, agg: RV[p.title] });
      });
    });
    if (!cards.length) { host.innerHTML = ''; return; }
    host.innerHTML = cards.map(function (c) { return favCardHTML(c.p, c.r, c.agg); }).join('');
    wireFavMore('#favsGrid');
  }
  /* Customer Favorites page — every 5-star review from a verified buyer, shown with the piece they reviewed */
  function favPageCards() {
    var groups = Object.keys(RV).map(function (title) {
      var stock = P.filter(function (p) { return p.title === title && inStock(p); });
      if (!stock.length) return null;
      var five = (RV[title].reviews || []).filter(function (r) { return r.r >= 5; });
      var used = {}, rot = 0;
      var cards = five.map(function (r) {
        var h = (r.u || '').replace(/^\/products\//, '');
        var p = stock.filter(function (x) { return x.handle === h; })[0];
        if (!p) { p = stock[rot % stock.length]; rot++; }
        used[p.handle] = (used[p.handle] || 0) + 1;
        var img = used[p.handle] % 2 === 0 && p.img2 ? p.img2 : p.img;
        return { p: p, r: r, agg: RV[title], img: img };
      });
      return cards.length ? cards : null;
    }).filter(Boolean).sort(function (a, b) { return b.length - a.length; });
    var out = [], more = true;
    for (var i = 0; more; i++) {
      more = false;
      groups.forEach(function (g) { if (g[i]) { out.push(g[i]); more = true; } });
    }
    return out;
  }
  function renderFavPage() {
    var host = $('#favPageGrid');
    if (!host) return;
    var cards = favPageCards();
    host.innerHTML = cards.map(function (c) { return favCardHTML(c.p, c.r, c.agg, c.img); }).join('');
    var n = $('#favPageCount');
    if (n) n.textContent = cards.length + ' five-star reviews from verified buyers';
    wireFavMore('#favPageGrid');
  }
  renderFavs();
  route();

  /* ---------------------------------------------------------
     TOAST
  --------------------------------------------------------- */
  var toastTimer;
  function toast(msg) {
    var t = $('#toast');
    t.textContent = msg;
    t.classList.add('is-on');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { t.classList.remove('is-on'); }, 2400);
  }

  /* ---------------------------------------------------------
     BOOT SEQUENCE
  --------------------------------------------------------- */
  /* popup timing is armed in the WELCOME block above */

  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (rows) {
      rows.forEach(function (r) {
        if (r.isIntersecting) {
          r.target.style.opacity = 1;
          r.target.style.transform = 'none';
          io.unobserve(r.target);
        }
      });
    }, { threshold: .12 });
    $$('.banner__copy, .rail__head, .trust__item').forEach(function (el) {
      el.style.opacity = 0;
      el.style.transform = 'translateY(14px)';
      el.style.transition = 'opacity .7s cubic-bezier(.22,.61,.36,1), transform .7s cubic-bezier(.22,.61,.36,1)';
      io.observe(el);
    });
  }
  window.TSL_APP = {
    cart: function () { return cart; },
    setCart: function (c) { cart = c; renderCart(); },
    discount: function () { return discount; },
    setDiscount: function (d) { discount = d; renderCart(); },
    byHandle: byHandle, open: open, close: close, toast: toast
  };
  if (window.TSL_BOOT) window.TSL_BOOT(window.TSL_APP);
})();
